// @ts-nocheck
import Coordinate from 'jsts/org/locationtech/jts/geom/Coordinate.js';
import Geometry from 'jsts/org/locationtech/jts/geom/Geometry.js';
import GeometryFactory from 'jsts/org/locationtech/jts/geom/GeometryFactory.js';
import GeoJSONWriter from 'jsts/org/locationtech/jts/io/GeoJSONWriter.js';
import GeoJSONReader from 'jsts/org/locationtech/jts/io/GeoJSONReader.js';
import isValidOp from 'jsts/org/locationtech/jts/operation/valid/IsValidOp.js';
import RelateOp from 'jsts/org/locationtech/jts/operation/relate/RelateOp.js';
import UnionOp from 'jsts/org/locationtech/jts/operation/union/UnionOp.js';
import OverlayOp from 'jsts/org/locationtech/jts/operation/overlay/OverlayOp.js';
import DistanceOp from 'jsts/org/locationtech/jts/operation/distance/DistanceOp.js';
import Centroid from 'jsts/org/locationtech/jts/algorithm/Centroid.js';
import InteriorPoint from 'jsts/org/locationtech/jts/algorithm/InteriorPoint.js';
import {area, polygon, multiPolygon} from "@turf/turf";
import proj4 from 'proj4';
import { api } from '../../../stores/api.ts';
import { get } from 'svelte/store';
import { closeModal, openModal } from 'svelte-modals';
import { z } from 'zod';
import InputNumberStepper from '../../shared/InputNumberStepper.svelte';
import ModalGridAlgorithmParams from './ModalGridAlgorithmParams.svelte';
import ModalInfo from '../../shared/Modals/ModalInfo.svelte';

import {JobsOnMap} from '../Jobs/JobsOnMap.js';
import {ZoneDataGenerator} from "./ZoneDataGenerator";
import {availableColors} from "../../utilities/availableColors";

Object.assign(Geometry.prototype, {
    isValid: function () {
        return isValidOp.isValid(this, ...arguments);
    },
    getValidationError: function() {
        let validOp = new isValidOp(this);
        return validOp.getValidationError();
    }
});
Object.assign(Geometry.prototype, {
    intersects: function () {
        return RelateOp.intersects(this, ...arguments);
    },
    intersection: function() {
        return OverlayOp.intersection(this, ... arguments);
    }
});
Object.assign(Geometry.prototype, {
    touches: function () {
        return RelateOp.touches(this, ...arguments);
    }
});
Object.assign(Geometry.prototype, {
    covers: function () {
        return RelateOp.covers(this, ...arguments);
    }
});
Object.assign(Geometry.prototype, {
    union: function () {
        return UnionOp.union(this, ...arguments);
    }
});
Object.assign(Geometry.prototype, {
    difference: function () {
        return OverlayOp.difference(this, ...arguments);
    }
});
Object.assign(Geometry.prototype, {
    getCentroid: function () {
        return Centroid.getCentroid(this, ...arguments);
    }
});
Object.assign(Geometry.prototype, {
    getInteriorPoint: function () {
        return InteriorPoint.getInteriorPoint(this, ...arguments);
    }
});

export class ZoneEditor extends EventTarget {

    constructor (options) {
        super();
        if (!options) {
            options = {};
        }
        options.grid = Object.assign({
            set: 'beta',
            active: false,
            visible: true,
            interactive: true,
            quickMove: true,
            opacity: 0.5
        }, options.grid || {});
        options = Object.assign({
            editable: true,
            snap: 20,
            slice: true,
            merge: true,
            //palette: ['#ef7576','#2b6391','#4cb049','#864590','#ffbe7f','#e93e95','#607c8a','#002d29'],
            palette: availableColors,
            arealimit: false,
            showLabels: true,
            ingoreIntersectionsSmallerThan: 10,
            polygonStyle: {strokeWeight: 3, strokeOpacity: 1, fillOpacity: 0.4},
            invalidStyle: (function(cell) {
                let pattern;
                let cnv = document.createElement('canvas');
                let ctx = cnv.getContext('2d');
                if (!this.invalidPatterns[cell.color]) {
                    pattern = new Image(50, 50);
                    pattern.src = Targeo.Base.getSVGSrc(('<circle cx="25" cy="25" r="10" style="fill: {color}; stroke-width: 0;"/><line x1="25" y1="18" x2="25" y2="27" style="stroke: #ffffff; stroke-width: 3;"/><circle cx="25" cy="30" r="2" style="fill: #ffffff; stroke-width: 0;"/>').replace('{color}', cell.color), 50, 50);
                    this.invalidPatterns[cell.color] = pattern;
                }
                pattern = ctx.createPattern(this.invalidPatterns[cell.color], 'repeat');
                return [{
                    strokeWeight: '0px',
                    fill: pattern
                }];
            }).bind(this),
            selectedStyle: (function(cell) {
                let pattern;
                let cnv = document.createElement('canvas');
                let ctx = cnv.getContext('2d');
                if (!this.selectedPatterns[cell.color]) {
                    let tile = document.createElement('canvas');
                    tile.width = 20;
                    tile.height = 20;
                    let tilectx = tile.getContext('2d');
                    tilectx.fillStyle = cell.color;
                    let tilepaths = [
                        [[0,0], [2,0], [20,18], [20,20], [18,20], [0,2]],
                        [[18,0], [20,0], [20,2]],
                        [[0,18], [2,20], [0,20]]
                    ];
                    for (let i = 0; i < tilepaths.length; i++) {
                        tilepaths[i].push(tilepaths[i][0]);
                        tilectx.beginPath();
                        tilectx.moveTo.apply(tilectx, tilepaths[i][0]);
                        for (let j = 0; j < tilepaths[i].length; j++) {
                            tilectx.lineTo.apply(tilectx, tilepaths[i][j]);
                        }
                        tilectx.closePath();
                        tilectx.fill();
                    }
                    this.selectedPatterns[cell.color] = tile;
                }
                pattern = ctx.createPattern(this.selectedPatterns[cell.color], 'repeat');
                return [{
                    strokeWeight: '0px',
                    fill: pattern
                }];
            }).bind(this),
            readOnlyOpacity: 0.35,
            createZoneFromCoords: false,
            vehicles: [],
            jobDateRange: [-2, 1],
            translateFunc: function(s) { return s; }
        }, options);

        Targeo.Base.addCSSs({
            '.map-zone-label': 'text-align: center; font-size: 11px; border-width: 0; border-radius: 5px; padding: 5px; opacity: 0.9; line-height: 1.3;',
            '.map-zone-label .title': 'font-size: 12px; font-weight: bold;',
            '.map-zone-label .warning': 'display: inline-block; border-radius: 2px; background-color: #c91d45; color: #ffffff; padding: 0 3px;'
        });

        this.Map = Targeo.Base.Map;
        this.options = options;

        this.id = (Date.now() * 1000 + Math.random() * 1000).toString(16).replace(/\./g, '');

        this.mapId = this.options.mapId;
        this.zones = {};
        this.polygons = {};
        this.stack = [];
        this.pinsAvailable = 0;
        this.pinsBooked = [];
        this.deliveryMap = null;
        this.deliveryPoints = [];
        this.deliveryPointsVisible = 2;
        this.listeners = {unload: []};
        this.isBusy = 0;
        this.mapsLeft = 0;
        this.invalidPatterns = {};
        this.selectedPatterns = {};
        this.selection = {polygons: {}, mergable: false};
        this.jobs = {};
        this.jobsLoader = null;
        this.polygonEditorListeners = [];
        this.editable = this.options.editable;
        this.editMode = this.options.grid && this.options.grid.active ? 'grid' : 'polygon';
        this.vehicles = {};
        this.conflictMarker = {
            marker: null,
            timeout: null,
            layer: new Targeo.MapObjectCollection(this.Map, {zIndex: 102}),
            step: 0
        }
        this.visible = true;
        this.lastUsedColor = null;
        this.zonePendingActions = {bulk: [], pending: []};

        if (this.options.showLabels) {
            this.labelsRefreshDisabled = false;
            this.mapMoveTO = null;
            this.Map.listen('onZoomChange', this.labelsRefresh.bind(this, null));
            this.Map.listen('onMoveEnd', function() {
                if (this.mapMoveTO) {
                    clearTimeout(this.mapMoveTO);
                }
                this.mapMoveTO = setTimeout((function() {
                    this.labelsRefresh(null);
                }).bind(this), 500);
            }, false, this);
        }
        if (this.options.merge) {
            this.Map.modules.ContextMenu.registerOption('joinZones_'+this.id, {
                label: this.options.translateFunc('editor_join_zones'),
                icon: Targeo.Base.getSVGSrc('<path fill="#62a025" d="M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"/>', 24, 24),
                handler: (function() {
                    this.polygonJoin();
                }).bind(this),
                active: true
            });
            this.Map.modules.ContextMenu.registerOption('mergeZones_'+this.id, {
                label: this.options.translateFunc('editor_merge_zones'),
                icon: Targeo.Base.getSVGSrc('<path fill="#62a025" d="M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"/>', 24, 24),
                handler: (function() {
                    this.polygonMerge();
                }).bind(this),
                active: false
            });
            this.Map.modules.ContextMenu.registerOption('splitZone_'+this.id, {
                label: this.options.translateFunc('editor_split_zone'),
                icon: Targeo.Base.getSVGSrc('<path fill="#62a025" d="M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z"/>', 24, 24),
                handler: (function(mapobj, evt) {
                    this.polygonSplit(mapobj, evt);
                }).bind(this)
            });
        }

        if (this.options.vehicles && this.options.vehicles.length) {
            for (let vehicle of this.options.vehicles) {
                this.vehicles[vehicle.id] = vehicle;
            }
        }

        this.jobDateRange = this.options.jobDateRange;
        this.volumeConfig = null;

        this.gridData = {};
        this.Map.listen('onZoomChange', this.gridLegend.bind(this));

        document.addEventListener('keydown', (function(event) {
            if (this.editable && event.code == 'KeyZ' && event.ctrlKey) {
                this.stateUndo();
            }
        }).bind(this));

    }

    init(zones) {
        let i, ii, j, p, z, c;
        let zone, polygon;
        let conflicts = [];
        let editable = this.editable;
        this.destroy();
        this.Map.getObjectManager().disableRefreshing('LastMile:areaEditor');
        for (i = 0, ii = zones.length; i < ii; i++) {
            zone = JSON.parse(JSON.stringify(zones[i]));
            if (!zone.area) {
                zone.area = area(zone.geom) / (1000 * 1000);
            }
            if (!zone.attributes) {
                zone.attributes = {};
            }
            this.zones[zone.id] = zone;
            if (zone.geom.type == 'Polygon') {
                zone.geom.coordinates[0] = zone.geom.coordinates[0].map(function(c) { return c.map(function(i) { return Math.round(i*10000000)/10000000; }); });
            } else {
                for (j = 0; j < zone.geom.coordinates.length; j++) {
                    zone.geom.coordinates[j][0] = zone.geom.coordinates[j][0].map(function(c) { return c.map(function(i) { return Math.round(i*10000000)/10000000; }); });
                }
            }
            polygon = this.polygonCreate(zone.geom, this.polygonGetStyle('base', zone.color));
            polygon._zone = zone.id;
            this.polygonAddLabel(polygon);
            this.zones[zone.id]._polygon = polygon;
            this.polygons[zone.id] = polygon;
            this.polygonSetValidityStyle(polygon);
            if (this.options.arealimit && this.options.arealimit < zone.area) {
                conflicts.push({zone: this.zones[zone.id], conflicts: {errors: [], warnings: [{type: 'zone-too-big'}]}});
            }
        }
        this.Map.getObjectManager().enableRefreshing('LastMile:areaEditor');
        if (editable) {
            this.setEditable(true);
        }
    }

    getZones() {
        return Object.values(this.zones).filter(zone => zone !== null);
    }

    destroy() {
        if (this.heartbeat) {
            clearInterval(this.heartbeat);
        }
        this.Map.getObjectManager().disableRefreshing('LastMile:areaEditor');
        this.setEditable(false);
        if (this.gridData && this.gridData.tetris) {
            this.gridTetrisModeStop();
        }
        for (var i = 0, ii = this.deliveryPoints.length; i < ii; i++) {
            this.Map.UORemove(this.deliveryPoints[i].id);
        }
        this.deliveryPoints = [];
        var zone;
        for (i in this.zones) {
            zone = this.zones[i];
            if (zone) {
                this.polygonRemoveLabel(zone._polygon);
                this.Map.UORemove(zone._polygon.id);
            }
        }
        this.Map.getObjectManager().enableRefreshing('LastMile:areaEditor');
        this.zones = {};
        this.polygons = {};
        //MochiKit.Iter.forEach(this.listeners.unload, MochiKit.Signal.disconnect);
        //this.listeners.unload = [];
        this.stack = [];
    }

    zoomToZone(zone_id) {
        if (this.zones[zone_id]) {
            console.log('zoomToZone', zone_id, this.polygons[zone_id]);
            this.Map.zoomToBounds(this.polygons[zone_id].getBounds());
        } else {
            console.warn('Zone not found', zone_id);
        }
    }

    setEditable(editable) {
        if (editable !== this.editable) {
            this.jobs = {};
            this.Map.getObjectManager().disableRefreshing('LastMile:areaEditor');
            this.editable = editable;
            if (editable) {
                if (ZoneEditor.activeEditor && ZoneEditor.activeEditor !== this) {
                    ZoneEditor.activeEditor.setEditable(false);
                }
                ZoneEditor.activeEditor = this;
                var polybounds, bounds, polyids = {};
                for (var i in this.polygons) {
                    //this.polygons[i].setOpacity(1);
                    this.polygons[i].setInteractive(this.editable);
                    this.polygons[i].setStyle(this.polygonGetStyle('base', this.zones[this.polygons[i]._zone].color));
                    this.polygonSetValidityStyle(this.polygons[i]);
                    if (this.polygons[i].label) {
                        for (var j = 0; j < this.polygons[i].label.length; j++) {
                            this.polygons[i].label[j].setOpacity(1);
                        }
                    }
                    polybounds = this.polygons[i].getBounds();
                    if (!bounds) {
                        bounds = polybounds;
                    } else {
                        bounds = {minX: Math.min(bounds.minX, polybounds.minX), minY: Math.min(bounds.minY, polybounds.minY), maxX: Math.max(bounds.maxX, polybounds.maxX), maxY: Math.max(bounds.maxY, polybounds.maxY)};
                    }
                    polyids[this.polygons[i].id] = true;
                    var zone = this.zones[this.polygons[i]._zone];
                }
                if (this.editMode == 'polygon') {
                    if (bounds) {
                        this.Map.zoomToBounds(bounds);
                    }
                    this.polygonEditorStart(polyids);
                } else {
                    this.gridModeStart();
                }
                this.stateSave();
                this.jobsLoader = new JobsOnMap({
                    type: 'jobs',
                    filter: this.getJobFilter(),
                    projection: ['id', 'geom', 'special_attributes>parcels@parcels', 'target_date'],
                    getMapObject: this.jobInit.bind(this)
                });
                this.jobsLoader.addEventListener('jobsload', (function() {
                    for (i in this.zones) {
                        if (this.zones[i]) {
                            this.polygonAddLabel(this.zones[i]._polygon);
                        }
                    }
                }).bind(this));
                if (this.options.grid) {
                    this.gridTetrisEstimateRoutes(Object.keys(this.zones));
                }
            } else {
                if (ZoneEditor.activeEditor === this) {
                    ZoneEditor.activeEditor = null;
                }
                if (this.editMode == 'grid') {
                    if (this.gridData.tetris) {
                        this.gridTetrisModeStop();
                    }
                    this.gridModeClose();
                }
                this.polygonEditorClose();
                for (var i in this.polygons) {
                    //this.polygons[i].setOpacity(this.options.readOnlyOpacity);
                    this.polygons[i].setStyle(this.polygonGetStyle('base', this.zones[this.polygons[i]._zone].color));
                    this.polygonSetValidityStyle(this.polygons[i]);
                    if (this.polygons[i].label) {
                        for (var j = 0; j < this.polygons[i].label.length; j++) {
                            this.polygons[i].label[j].setOpacity(0);
                        }
                    }
                }
                if (this.jobsLoader) {
                    this.jobsLoader.destroy();
                    this.jobsLoader = null;
                }
                if (this.options.grid) {
                    Targeo.Base.Map.tileLayerRemove('grid_cells');
                    Targeo.Base.Map.tileLayerRemove('grid_data');
                }
            }
            this.Map.getObjectManager().enableRefreshing('LastMile:areaEditor');
        }
    }

    isEditable() {
        return this.editable;
    }

    toggleVisibility(visible) {
        if (typeof(visible) == 'boolean') {
            if (this.visible == visible) {
                return;
            }
            this.visible = visible;
        } else {
            this.visible = !this.visible;
        }
        for (var i in this.polygons) {
            this.polygons[i].setStyle(this.polygonGetStyle('base', this.zones[this.polygons[i]._zone].color));
            this.polygonSetValidityStyle(this.polygons[i]);
            this.polygonSetLabelOpacity(this.polygons[i]);
        }
    }

    zoneBulkActionInit(id) {
        var actionIdx = this.zonePendingActions.bulk.findIndex(a => a.id == id);
        if (actionIdx == -1) {
            this.zonePendingActions.bulk.push({id: id, completed: false, zones: {}});
        }
    }

    zoneBulkActionComplete(id) {
        var actionIdx = this.zonePendingActions.bulk.findIndex(a => a.id == id);
        if (actionIdx >= 0) {
            var action = this.zonePendingActions.bulk[actionIdx];
            action.completed = true;
            this.zoneBulkActionsFinish();
        }
    }

    zoneBulkActionsFinish() {
        console.log('zoneBulkActionsFinish (1)', this.zonePendingActions.pending.length);
        if (this.zonePendingActions.pending.length == 0) {
            var completedBulks = this.zonePendingActions.bulk.filter(b => b.completed);
            console.log('zoneBulkActionsFinish (2)', completedBulks.length);
            if (completedBulks.length > 0) {
                var pendingBulks = this.zonePendingActions.bulk.filter(b => !b.completed);
                console.log('zoneBulkActionsFinish (2)', pendingBulks.length);
                if (pendingBulks.length === 0) {
                    var zonesToAutoSave = {};
                    for (var i = this.zonePendingActions.bulk.length - 1; i >= 0; i--) {
                        if (this.zonePendingActions.bulk[i].completed) {
                            zonesToAutoSave = Object.assign(zonesToAutoSave, this.zonePendingActions.bulk[i].zones);
                        }
                        this.zonePendingActions.bulk.splice(i, 1);
                    }
                    if (Object.keys(zonesToAutoSave).length) {
                        this.zonesAutoSave(zonesToAutoSave).then((response) => {
                            if (this.editMode == 'grid') {
                                this.gridRefreshMap();
                            }
                            if (this.options.grid) {
                                this.gridTetrisEstimateRoutes(Object.keys(zonesToAutoSave));
                            }
                        });
                    }
                    this.stateSave();
                }
            }
        }
    }

    zoneRemove(id) {
        if (this.zones[id]) {
            this.polygonRemove(this.polygons[id], true);
        }
    }

    zoneChange(zone, updateState) {
        if (this.zones[zone.id]) {
            var current = this.zones[zone.id];
            var cmp = ['name', 'color', 'vehicle_id'];
            var changed = false;
            var modifications = {};
            for (var i of cmp) {
                if (zone[i] != current[i]) {
                    modifications[i] = zone[i];
                    changed = true;
                }
            }
            if (changed) {
                this.zones[zone.id] = Object.assign(current, modifications);
                this.polygonAddLabel(this.zones[zone.id]._polygon);
                this.zones[zone.id]._polygon.setStyle(this.polygonGetStyle('base', zone.color));
                if (updateState) {
                    this.stateUpdate(zone.id);
                } else {
                    this.stateSave();
                }
            }
        }
        console.log('zoneChange', zone, this.zones[zone.id], changed);
    }

    zoneChangeGeometry(zoneId, geojson) {
        var mapobj = this.zones[zoneId]._polygon;
        mapobj.setPoints(geojson.coordinates);
        if (mapobj._zone) {
            this.zones[zoneId].geom = geojson;
            this.zones[zoneId].area = area(geojson) / (1000 * 1000);
            this.polygonAddJSTS(mapobj);
            this.polygonSetValidityStyle(mapobj);
            this.polygonAddLabel(mapobj);
            var zonesToAutoSave = {};
            zonesToAutoSave[zoneId] = geojson;
            this.zonesAutoSave(zonesToAutoSave);
            this.stateSave();
        }
    }

    zoneGetContrastingColor(zone) {
        var color = {r: parseInt(zone.color.substr(1, 2), 16), g: parseInt(zone.color.substr(3, 2), 16), b: parseInt(zone.color.substr(5, 2), 16)};
        color = (color.r * 0.299 + color.g * 0.587 + color.b * 0.114) > 186 ? '#000000' : '#ffffff';
        return color;
    }

    polygonCreate(geojson, style) {
        var poly = new Targeo.MapObject.Polyline(geojson.coordinates, {closed: true, interactive: this.editable, drawStyle: style, mouseButtonActions: {right: 'contextmenu'}, fGetContextMenu: this.polygonContextMenu.bind(this)});
        this.polygonAddJSTS(poly);
        if (style) {
            this.Map.UOAdd(poly);
        }
        return poly;
    }

    polygonContextMenu(objid) {
        var opts = [];
        if (this.editMode == 'polygon') {
            if (Object.keys(this.selection.polygons).length > 1 && objid in this.selection.polygons) {
                opts.push('joinZones_'+this.id);
                opts.push('mergeZones_'+this.id);
            }
            if (this.Map.getObjectManager().objects[objid].getGeometryType() == 'MultiPolygon') {
                opts.push('splitZone_'+this.id);
            }
        } else if (objid in this.selection.polygons) {
            var selectionSize = Object.keys(this.selection.polygons).length
            if (selectionSize >= 2) {
                var balanceable = true;
                var notBalanceableReason = '';
                if (!this.selection.mergeable) {
                    for (var i in this.selection.polygons) {
                        var touches = false;
                        for (var j in this.selection.polygons) {
                            if (i != j && (this.selection.polygons[i].jsts.intersects(this.selection.polygons[j].jsts) || this.selection.polygons[i].jsts.touches(this.selection.polygons[j].jsts))) {
                                touches = true;
                                break;
                            }
                        }
                        if (!touches) {
                            balanceable = false;
                            notBalanceableReason = this.options.translateFunc('editor_cannot_balance_disjoint_zones');
                            break;
                        }
                    }
                }
                if (balanceable) {
                    if (Object.values(this.selection.polygons).map((p) => this.zones[p._zone].attributes.volume).filter((v) => v && v.volume > 0).length == 0) {
                        balanceable = false;
                        notBalanceableReason = this.options.translateFunc('editor_cannot_balance_empty_zones');
                    } else {
                        var maxDelta = 0;
                        var volumes = Object.values(this.selection.polygons).map((p) => this.zones[p._zone].attributes.volume).map((v) => v && v.volume ? v.volume : 0);
                        for (var i = 0; i < volumes.length; i++) {
                            for (var j = i + 1; j < volumes.length; j++) {
                                maxDelta = Math.max(maxDelta, Math.abs(volumes[i] - volumes[j]));
                            }
                        }
                        if (maxDelta < 5) {
                            balanceable = false;
                            notBalanceableReason = this.options.translateFunc('editor_cannot_balance_similar_zones');
                        }
                    }
                }
                opts.push({
                    label: this.options.translateFunc('editor_balance_zones'),
                    icon: Targeo.Base.getSVGSrc('<g stroke="#62a025" stroke-width="5" stroke-linecap="round"><path d="M46 8v10l-10 10l10 10v10 10l10 10l-10 10v10" fill="none" stroke-width="8" stroke-linecap="butt"/><line x1="80" y1="28" x2="60" y2="28"/><line x1="67" y1="21" x2="60" y2="28"/><line x1="67" y1="35" x2="60" y2="28"/><line x1="12" y1="68" x2="32" y2="68"/><line x1="25" y1="61" x2="32" y2="68"/><line x1="25" y1="75" x2="32" y2="68"/></g>', 96, 96),
                    handler: (function() {
                        this.gridBalanceZones2();
                    }).bind(this),
                    active: balanceable,
                    hint: notBalanceableReason
                });
            }
            var partionable = selectionSize == 1 || (this.selection.mergeable && selectionSize > 2);
            var notPartionableReason = '';
            if (partionable) {
                if (selectionSize == 1) {
                    var selectedPolygon = Object.values(this.selection.polygons)[0];
                    var neighbours = 0;
                    for (var i in this.polygons) {
                        if (this.polygons[i] !== selectedPolygon && this.polygons[i].jsts.intersects(selectedPolygon.jsts)) {
                            neighbours++;
                        }
                    }
                    if (neighbours < 2) {
                        partionable = false;
                        notPartionableReason = this.options.translateFunc('editor_cannot_partition_too_few_neighbours');
                    }
                }
            } else {
                if (!this.selection.mergeable) {
                    notPartionableReason = this.options.translateFunc('editor_cannot_partition_disjoint_zones');
                } else {
                    notPartionableReason = this.options.translateFunc('editor_cannot_partition_too_few_neighbours');
                }
            }
            opts.push({
                label: this.options.translateFunc('editor_partition_zone'),
                icon: Targeo.Base.getSVGSrc('<g stroke="#62a025" stroke-width="5" stroke-linecap="round"><path d="M48 80v-25l23 -18l-23 18l-23 -18" fill="none" stroke-width="8" stroke-linecap="butt"/><line x1="48" y1="32" x2="48" y2="13"/><line x1="48" y1="13" x2="41" y2="20"/><line x1="48" y1="13" x2="55" y2="20"/> <g transform="rotate(45, 67, 63)"><line x1="67" y1="63" x2="87" y2="63"/><line x1="80" y1="56" x2="87" y2="63"/><line x1="80" y1="70" x2="87" y2="63"/></g><g transform="rotate(135, 29, 62)"><line x1="29" y1="62" x2="49" y2="62"/><line x1="42" y1="55" x2="49" y2="62"/><line x1="42" y1="69" x2="49" y2="62"/></g></g>', 96, 96),
                handler: (function(obj) {
                    this.gridPartitionZone2(obj);
                }).bind(this),
                active: partionable,
                hint: notPartionableReason
            });
        }
        return opts;
    }

    polygonGetStyle(type, color) {
        var style;
        switch (type) {
            case 'base':
                var baseStyle = Object.assign({}, this.options.polygonStyle);
                if (this.visible) {
                    if (!this.editable) {
                        baseStyle.strokeOpacity *= this.options.readOnlyOpacity;
                        baseStyle.fillOpacity *= this.options.readOnlyOpacity;
                    }
                } else {
                    baseStyle.strokeOpacity = 0;
                    baseStyle.fillOpacity = 0;
                }
                style = [Object.assign(baseStyle, {strokeColor: color, fill: color})];
                break;
        }
        return style;
    }

    polygonSetValidityStyle(mapobj) {
        var zone = this.zones[mapobj._zone];
        var valid = mapobj.isValid && (!this.options.arealimit || zone.area < this.options.arealimit);
        var style = this.polygonGetStyle('base', zone.color);
        var invstyle = this.options.invalidStyle(zone);
        if (!valid && this.editable) {
            if (!this.invalidPatterns[zone.color].complete) {
                this.invalidPatterns[zone.color].onload = this.polygonSetValidityStyle.bind(this, mapobj);
                return;
            }
            style.unshift.apply(style, invstyle);
        }
        mapobj.setStyle(style);
    }

    polygonAddLabel(poly) {
        if (!this.options.showLabels) {
            return;
        }
        this.polygonRemoveLabel(poly);
        var zone = this.zones[poly._zone];
        var vehicle = zone.vehicle_id && this.vehicles[zone.vehicle_id] ? this.vehicles[zone.vehicle_id] : {};
        var color = this.zoneGetContrastingColor(zone);
        var text = [];
        if (zone.name) text.push('<div><span class="title">'+zone.name+'</span></div>');
        if (typeof(zone.vehicle_id) != 'number') {
            text.push('<img src="'+Targeo.Base.getSVGSrc(ZoneEditor.iconNoVehicle, 48, 48)+'" style="width: 24px; height: 24px; position: relative; top: -1px" title="'+this.options.translateFunc('editor_zone_label_no_driver')+'"/>');
        }
        if (text.length) {
            text = ['<div style="display: flex; flex-direction: row; justify-content: center; align-items: center; gap: 15px;">'+text.join('')+'</div>'];
        }
        if (zone.attributes && zone.attributes.volume) {
            var attrs = [];
            if ('jobs' in zone.attributes.volume) {
                attrs.push('<div><img src="'+Targeo.Base.getSVGSrc(ZoneEditor.iconJob.replace('{color}', color), 16, 16)+'" style="width: 16px; height: 16px; vertical-align: middle; margin-right: 2px" title="'+this.options.translateFunc('editor_zone_label_deliveries')+'"/> '+(vehicle.delivery_limit && vehicle.delivery_limit < zone.attributes.volume.jobs ? '<span class="warning">'+zone.attributes.volume.jobs+'</span>' : zone.attributes.volume.jobs)+(vehicle.delivery_limit ? ' / '+vehicle.delivery_limit : '')+'</div>');
            }
            if ('parcels' in zone.attributes.volume) {
                attrs.push('<div><img src="'+Targeo.Base.getSVGSrc(ZoneEditor.iconParcel.replace('{color}', color), 16, 16)+'" style="width: 16px; height: 16px; vertical-align: middle; margin-right: 2px" title="'+this.options.translateFunc('editor_zone_label_parcels')+'"/> '+(vehicle.parcel_limit && vehicle.parcel_limit < zone.attributes.volume.parcels ? '<span class="warning">'+zone.attributes.volume.parcels+'</span>' : zone.attributes.volume.parcels)+(vehicle.parcel_limit  ? ' / '+vehicle.parcel_limit : '')+'</div>');
            }
            if ('stops' in zone.attributes.volume) {
                attrs.push('<div><img src="'+Targeo.Base.getSVGSrc(ZoneEditor.iconStop.replace('{color}', color), 16, 16)+'" style="width: 16px; height: 16px; vertical-align: middle; margin-right: 2px" title="'+this.options.translateFunc('editor_zone_label_stops')+'"/> '+(vehicle.stop_limit && vehicle.stop_limit < zone.attributes.volume.stops ? '<span class="warning">'+zone.attributes.volume.stops+'</span>' : zone.attributes.volume.stops)+(vehicle.stop_limit  ? ' / '+vehicle.stop_limit : '')+'</div>');
            }
            if (attrs.length) {
                text.push('<div style="display: flex; flex-direction: row; justify-content: center; align-items: center; gap: 15px;">'+attrs.join('')+'</div>');
            }
            attrs = [];
            if ('volume' in zone.attributes.volume) {
                attrs.push('<div><img src="'+Targeo.Base.getSVGSrc(ZoneEditor.gridTetrisLoadIcon.replace('{color}', color), 16, 16)+'" style="width: 16px; height: 16px; vertical-align: middle; margin-right: 2px" title="'+this.options.translateFunc('editor_zone_label_volume')+'"/> '+(Math.round(zone.attributes.volume.volume*100)/100).toLocaleString()+'</div>');
            }
            if (zone.attributes.route && zone.attributes.route.eta && !zone.attributes.route.recalculating) {
                attrs.push('<div><img src="'+Targeo.Base.getSVGSrc(ZoneEditor.gridTetrisDurationIcon.replace(/\{color\}/g, color))+'" style="width: 16px; height: 16px; vertical-align: middle; margin-right: 2px"/>'+this.formatRouteDuration(zone.attributes.route.eta)+'</div>');
            }
            if (attrs.length) {
                text.push('<div style="display: flex; flex-direction: row; justify-content: center; align-items: center; gap: 15px;">'+attrs.join('')+'</div>');
            }
        }
        text = '<div class="map-zone-label" style="color: '+color+'; background-color: '+zone.color+'">'+text.join('')+'</div>';
        var i;
        poly.label = [];
        if (poly.getGeometryType() === 'MultiPolygon') {
            var geoms = poly.jsts.getNumGeometries();
            for (i = 0; i < geoms; i++) {
                poly.label.push(new Targeo.MapObject.DOM(poly.jsts.getGeometryN(i).getCentroid(), text, null, {interactive: false, visible: false, opacity: this.polygonGetLabelOpacity()}));
                this.Map.UOAdd(poly.label[i]);
            }
        } else {
            poly.label.push(new Targeo.MapObject.DOM(poly.jsts.getCentroid(), text, null, {interactive: false, visible: false, opacity: this.polygonGetLabelOpacity()}));
            this.Map.UOAdd(poly.label[0]);
        }
        var refresh = {};
        refresh[poly._zone] = poly;
        this.labelsRefresh(refresh);
    }

    polygonRemoveLabel(poly) {
        if (poly.label) {
            for (var i = 0; i < poly.label.length; i++) {
                this.Map.UORemove(poly.label[i].id);
            }
        }
        poly.label = null;
    }

    polygonGetLabelOpacity() {
        return this.visible && this.editable && (!this.gridData || !this.gridData.tetris) ? 1 : 0;
    }

    polygonSetLabelOpacity(poly) {
        if (poly.label) {
            var opacity = this.polygonGetLabelOpacity();
            for (var i = 0; i < poly.label.length; i++) {
                poly.label[i].setOpacity(opacity);
            }
        }
    }

    polygonAddJSTS(mapobj) {
        var multi = mapobj.getGeometryType() == 'MultiPolygon';
        var jstsPoly = [], i, j;
        if (multi) {
            for (i = 0; i < mapobj.points.length; i++) {
                jstsPoly.push(mapobj.points[i][0].map(function(p) { return new Coordinate(p[0], p[1]); }));
                jstsPoly[i] = (new GeometryFactory()).createPolygon(jstsPoly[i]);
            }
            mapobj.jsts = (new GeometryFactory()).createMultiPolygon(jstsPoly);
        } else {
            jstsPoly = mapobj.points[0].map(function(p) { return new Coordinate(p[0], p[1]); });
            mapobj.jsts = (new GeometryFactory()).createPolygon(jstsPoly);
        }
        mapobj.dimensions = [];
        if (mapobj.getGeometryType() == 'MultiPolygon') {
            var geoms = mapobj.jsts.getNumGeometries();
            var geom;
            mapobj.isValid = true;
            for (i = 0; i < geoms; i++) {
                geom = mapobj.jsts.getGeometryN(i);
                if (mapobj.isValid) {
                    if (geom.isValid()) {
                        for (j = 0; j < i; j++) {
                            if (geom.intersects(mapobj.jsts.getGeometryN(j)) && !geom.touches(mapobj.jsts.getGeometryN(j))) {
                                mapobj.isValid = false;
                                break;
                            }
                        }
                    } else {
                        mapobj.isValid = false;
                    }
                }
                let envelope = geom.getEnvelope().getCoordinates();
                mapobj.dimensions.push({minx: envelope[0].x, miny: envelope[0].y, maxx: envelope[2].x, maxy: envelope[2].y});
            }
        } else {
            mapobj.isValid = mapobj.jsts.isValid();
            let envelope = mapobj.jsts.getGeometryN(0).getEnvelope().getCoordinates();
            if (envelope.length > 2) {
                mapobj.dimensions.push({minx: envelope[0].x, miny: envelope[0].y, maxx: envelope[2].x, maxy: envelope[2].y});
            } else {
                mapobj.dimensions.push({minx: envelope[0].x, miny: envelope[0].y, maxx: envelope[0].x, maxy: envelope[0].y});
            }
        }
        var proj4326 = new proj4.Proj('EPSG:4326');
        var proj3857 = new proj4.Proj('EPSG:3857');
        mapobj.dimensions = mapobj.dimensions.map(function(pextent) {
            pextent = [proj4.transform(proj4326, proj3857, proj4.toPoint([pextent.minx, pextent.miny])), proj4.transform(proj4326, proj3857, proj4.toPoint([pextent.maxx, pextent.maxy]))];
            return {width: pextent[1].x - pextent[0].x, height: pextent[1].y - pextent[0].y}
        });
    }

    polygonOnDraw(evt) {
        var coords = (new GeometryFactory()).createPoint(new Coordinate(evt.gps_coordinate[0], evt.gps_coordinate[1]));
        for (var z in this.zones) {
            if (this.zones[z] && this.zones[z]._polygon.isValid && this.zones[z]._polygon.jsts.covers(coords)) {
                this.polygonOnClick(this.zones[z]._polygon, evt);
                return false;
            }
        }
        if (evt.originalEvent.ctrlKey && this.options.createZoneFromCoords) {
            this.dispatchEvent(new CustomEvent('zoneAddFromCoords', {detail: {coords: {x: evt.gps_coordinate[0], y: evt.gps_coordinate[1]}}}));
        } else {
            this.polygonClearSelection();
            return true;
        }
    }

    polygonOnClick(mapobj, evt) {
        this.Map.modules.ContextMenu.hide();
        if (this.options.merge && evt.originalEvent.ctrlKey) {
            this.polygonToggleSelection(mapobj, evt);
        }
    }

    polygonToggleSelection(mapobj, evt) {
        mapobj._selected = !mapobj._selected;
        var zone = this.zones[mapobj._zone];
        var style = this.polygonGetStyle('base', zone.color);
        var selstyle = this.options.selectedStyle(zone);
        var i, j, h;
        if (mapobj._selected) {
            style.unshift.apply(style, selstyle);
            this.selection.polygons[mapobj.id] = mapobj;
        } else {
            delete(this.selection.polygons[mapobj.id]);
        }
        this.selection.mergeable = false;
        if (Object.keys(this.selection.polygons).length > 1) {
            var union;
            for (i in this.selection.polygons) {
                if (!union) {
                    var multi = this.selection.polygons[i].getGeometryType() == 'MultiPolygon';
                    var jstsPoly = [];
                    if (multi) {
                        for (j = 0; j < this.selection.polygons[i].points.length; j++) {
                            jstsPoly.push(this.selection.polygons[i].points[j][0].map(function(p) { return new Coordinate(p[0], p[1]); }));
                            jstsPoly[j] = (new GeometryFactory()).createPolygon(jstsPoly[j]);
                        }
                        jstsPoly = (new GeometryFactory()).createMultiPolygon(jstsPoly);
                    } else {
                        jstsPoly = this.selection.polygons[i].points[0].map(function(p) { return new Coordinate(p[0], p[1]); });
                        jstsPoly = (new GeometryFactory()).createPolygon(jstsPoly);
                    }
                    union = jstsPoly;
                } else {
                    union = union.union(this.selection.polygons[i].jsts);
                }
            }
            this.selection.union = union;
            if (union.isValid()) {
                this.selection.mergeable = true;
                var geoms = union.getNumGeometries();
                if (geoms > 1) {
                    this.selection.mergeable = false;
                } else {
                    var unionarea = area({type: 'Polygon', coordinates: [union.getExteriorRing().getCoordinates().map(function(c){ return [c.x, c.y]; })]});
                    var holes = union.getNumInteriorRing();
                    if (holes > 0) {
                        for (h = 0; h < holes; h++) {
                            var ring = union.getInteriorRingN(h);
                            if (area({type: 'Polygon', coordinates: [ring.getCoordinates().map(function(c){ return [c.x, c.y]; })]}) < unionarea * 0.05) {
                                var hole = (new GeometryFactory()).createPolygon(ring);
                                for (j in this.polygons) {
                                    if (!(this.polygons[j].id in this.selection.polygons) && hole.intersects(this.polygons[j].jsts)) {
                                        this.selection.mergeable = false;
                                        break;
                                    }
                                }
                            } else {
                                this.selection.mergeable = false;
                                break;
                            }
                        }
                    }
                }
            }
        }
        if (this.selection.mergeable) {
            this.Map.modules.ContextMenu.activateOption('mergeZones_'+this.id);
        } else {
            this.Map.modules.ContextMenu.disactivateOption('mergeZones_'+this.id);
        }
        mapobj.setStyle(style);
    }

    polygonClearSelection() {
        this.Map.modules.ContextMenu.hide();
        if (this.options.merge) {
            for (var i in this.selection.polygons) {
                this.selection.polygons[i]._selected = false;
                this.selection.polygons[i].setStyle(this.polygonGetStyle('base', this.zones[this.selection.polygons[i]._zone].color));
            }
            this.selection = {polygons: {}, mergeable: false};
            this.Map.modules.ContextMenu.disactivateOption('mergeZones_'+this.id);
        }
    }

    polygonMerge() {
        var points = [];
        var geoms = this.selection.union.getNumGeometries();
        for (var i = 0; i < geoms; i++) {
            points.push([this.selection.union.getGeometryN(i).getExteriorRing().getCoordinates().map(function(c) { return [c.x, c.y]; })]);
        }
        if (geoms == 1) {
            points = points[0];
        }
        var polygons = Object.values(this.selection.polygons);
        this.polygonClearSelection();
        var mapobj, first = true;
        this.bulkChange = true;
        for (i = 0; i < polygons.length; i++) {
            mapobj = polygons[i];
            if (first) {
                mapobj.setPoints(points);
                this.polygonAddJSTS(mapobj);
                this.polygonSetValidityStyle(mapobj);
                this.polygonAddLabel(mapobj);
                mapobj.setStyle(this.polygonGetStyle('base', this.zones[mapobj._zone].color));
                this.zones[mapobj._zone].area = area({type: mapobj.getGeometryType(), coordinates: points}) / (1000 * 1000);
                first = false;
                let newgeoms = {};
                newgeoms[mapobj._zone] = {type: mapobj.getGeometryType(), coordinates: JSON.parse(JSON.stringify(mapobj.points))};
                this.zonesOnChange(newgeoms, []);
            } else {
                this.polygonRemove(mapobj, false);
            }
        }
        this.bulkChange = false;
        this.stateSave();
    }

    polygonJoin() {
        var polygons = Object.values(this.selection.polygons);
        this.polygonClearSelection();
        var mapobj, first = true;
        var points = [];
        var i, j;
        for (i = 0; i < polygons.length; i++) {
            mapobj = polygons[i];
            if (mapobj.getGeometryType() == 'Polygon') {
                points.push(JSON.parse(JSON.stringify(mapobj.points)));
            } else {
                for (j = 0; j < mapobj.points.length; j++) {
                    points.push(JSON.parse(JSON.stringify(mapobj.points[j])));
                }
            }
        }
        this.bulkChange = true;
        for (i = 0; i < polygons.length; i++) {
            mapobj = polygons[i];
            if (first) {
                mapobj.setPoints(points);
                this.polygonAddJSTS(mapobj);
                this.polygonSetValidityStyle(mapobj);
                this.polygonAddLabel(mapobj);
                mapobj.setStyle(this.polygonGetStyle('base', this.zones[mapobj._zone].color));
                this.zones[mapobj._zone].area = area(mapobj.getGeometryType() == 'Polygon' ? polygon(points) : multiPolygon(points)) / (1000 * 1000);
                first = false;
                let newgeoms = {};
                newgeoms[mapobj._zone] = {type: mapobj.getGeometryType(), coordinates: JSON.parse(JSON.stringify(mapobj.points))};
                this.zonesOnChange(newgeoms, []);
            } else {
                this.polygonRemove(mapobj, false);
            }
        }
        this.bulkChange = false;
        this.stateSave();
    }

    polygonSplit(mapobj, evt) {
        this.polygonClearSelection();
        var geoms = mapobj.jsts.getNumGeometries();
        var polygon;
        for (var i = 0; i < geoms; i++) {
            polygon = mapobj.jsts.getGeometryN(i);
            if (polygon.covers((new GeometryFactory()).createPoint(new Coordinate(evt.gpsCoords.x, evt.gpsCoords.y)))) {
                var points = JSON.parse(JSON.stringify(mapobj.points));
                var newpolygon = points.splice(i, 1)[0];
                if (points.length == 1) {
                    points = points[0];
                }
                mapobj.setPoints(points);
                mapobj.setStyle(this.polygonGetStyle('base', this.zones[mapobj._zone].color));
                this.polygonAddJSTS(mapobj);
                this.polygonAddLabel(mapobj);
                this.polygonSetValidityStyle(mapobj);
                let newgeoms = {};
                newgeoms[mapobj._zone] = {type: mapobj.getGeometryType(), coordinates: JSON.parse(JSON.stringify(mapobj.points))};
                this.zonesOnChange(newgeoms, []);
                newpolygon = new Targeo.MapObject.Polyline(newpolygon, {closed: true});
                this.Map.UOAdd(newpolygon);
                this.polygonOnAdd({object: newpolygon});
                this.Map.modules.PolygonEditor.addPolygon(newpolygon, true);
                break;
            }
        }
    }

    polygonAdd(geojson, vehicleId) {
        var mapobj = this.polygonCreate(geojson);
        this.polygonOnAdd({object: mapobj, vehicle_id: vehicleId}).then(() => {
            this.Map.UOAdd(mapobj);
            if (this.editMode == 'polygon') {
                this.Map.modules.PolygonEditor.addPolygon(mapobj, true);
            }
        });
    }

    polygonRemove(polygon, saveState) {
        this.polygonRemoveLabel(polygon);
        this.Map.UORemove(polygon.id);
        if (this.gridData && this.gridData.tetris && this.gridData.tetris.zones[polygon._zone]) {
            this.Map.UORemove(this.gridData.tetris.zones[polygon._zone].handle.id);
            this.Map.UORemove(this.gridData.tetris.zones[polygon._zone].label.id);
            delete(this.gridData.tetris.zones[polygon._zone]);
        }
        var zone = this.zones[polygon._zone];
        this.zones[polygon._zone] = null;
        delete(this.polygons[polygon._zone]);
        this.jobsRefresh([polygon._zone]);
        if (saveState) {
            this.stateSave();
            if (this.zonePendingActions.bulk.length == 0) {
                var zonesToAutoSave = {};
                zonesToAutoSave[zone.id] = null;
                this.zonesAutoSave(zonesToAutoSave).then((response) => {
                    if (this.editMode == 'grid') {
                        this.gridRefreshMap();
                    }
                });
            } else {
                this.zonePendingActions.bulk[0].zones[zone.id] = null;
            }
        }
        this.dispatchEvent(new CustomEvent('zoneRemove', {detail: {zone_id: zone.id}}));
    }

    polygonOnAdd(evt) {
        return new Promise((resolve, reject) => {
            if (!evt.coordinates || evt.coordinates[0].length > 3) {
                var mapobj = evt.object;
                this.zonePendingActions.pending.push({type: 'add', id: 'polygon:'+mapobj.id});
                var points, geom;
                if (evt.coordinates) {
                    points = [evt.coordinates[0].map(function(c) { for (var i in c) c[i] = Math.round(c[i]*10000000)/10000000; return c; })];
                    mapobj.setPoints(points);
                    geom = {type: 'Polygon', coordinates: points};
                } else {
                    points = mapobj.points;
                    geom = {type: mapobj.getGeometryType(), coordinates: JSON.parse(JSON.stringify(mapobj.points))}
                }
                this.polygonAddJSTS(mapobj);
                var i, c;
                var colors = JSON.parse(JSON.stringify(this.options.palette));
                let newColor = '';

                try {
                    for (i in this.zones) {
                        if (this.zones[i] && (mapobj.jsts.touches(this.zones[i]._polygon.jsts) || mapobj.jsts.intersects(this.zones[i]._polygon.jsts))) {
                            if ((c = colors.indexOf(this.zones[i].color)) >= 0) {
                                colors.splice(c, 1);
                            }
                        }
                    }
                } catch (e) {
                    console.error('Error checking touches/intersects for new zone', e);
                }

                // Use color from the palette of available colors
                let alreadyExistsColors = Object.values(this.zones).filter(zone => zone!==null).map((zone) => zone.color);
                if (this.lastUsedColor) {
                    alreadyExistsColors.push(this.lastUsedColor);
                }
                newColor = this.lastUsedColor = ZoneDataGenerator.generateColor(alreadyExistsColors, colors);

                this.zonesAutoSave({_: geom}).then(response => {

                    // let newId = '_'+(new Date().getTime()).toString(16);
                    // let newNo = 0;
                    // var zone = {id: newId+newNo, name: '', color: newColor, geom: geom, vehicle_id: evt.vehicle_id || null};
                    // while (zone.id in this.zones) {
                    //     newNo++;
                    //     zone.id = newId+newNo;
                    // }

                    var zone = {id: response['_'], name: '', color: newColor, geom: geom, vehicle_id: evt.vehicle_id || null};
                    zone.area = area(zone.geom) / (1000 * 1000);
                    zone._polygon = mapobj;
                    this.zones[zone.id] = zone;
                    mapobj._zone = zone.id;
                    this.polygons[zone.id] = mapobj;
                    mapobj.setStyle(this.polygonGetStyle('base', zone.color));
                    mapobj.setFGetContextMenu(this.polygonContextMenu.bind(this));
                    mapobj.setMouseButtonAction('right', 'contextmenu');
                    this.polygonSetValidityStyle(mapobj);
                    this.jobsRefresh({'!': 1});
                    // setTimeout((function() {
                    //     var polyconflicts = {warnings: [], errors: []};
                    //     if (!mapobj.isValid) {
                    //         polyconflicts.errors.push({type: 'self-intersection'});
                    //     } else {
                    //         if (this.options.arealimit && this.options.arealimit < this.zones[mapobj._zone].area) {
                    //             polyconflicts.warnings.push({type: 'zone-too-big'});
                    //         }
                    //         polyconflicts = this.checkIntersections(mapobj, polyconflicts);
                    //     }
                    //     if (polyconflicts.warnings.length || polyconflicts.errors.length) {
                    //         //MochiKit.Signal.signal(this, 'onConflict', [{poly: mapobj, zone: this.zones[mapobj._zone], conflicts: polyconflicts}], true);
                    //     }
                    // }).bind(this), 0);
                    console.log('addZone, this.polygons',this.polygons);
                    this.drawing = false;
                    this.polygonAddLabel(mapobj);

                    var pendingAction = this.zonePendingActions.pending.findIndex((a) => a.type == 'add' && a.id == 'polygon:'+mapobj.id);
                    if (pendingAction >= 0) {
                        this.zonePendingActions.pending.splice(pendingAction, 1);
                    }

                    if (this.zonePendingActions.pending.length == 0) {

                        if (this.zonePendingActions.bulk.length == 0) {
                            var stateAttributes = null;

                            if (this.editMode == 'grid') {
                                if (this.gridData.pendingModifications) {
                                    this.gridModify(this.gridData.pendingModifications);
                                    this.gridData.pendingModifications.zones[zone.id] = zone.geom;
                                    stateAttributes = {grid: {cell_id: this.gridData.pendingModifications.cell_id, zones: Object.keys(this.gridData.pendingModifications.zones)}};
                                    this.gridData.pendingModifications = null;
                                } else {
                                    this.gridRefreshMap();
                                }
                            }

                            this.stateSave(stateAttributes);
                        } else {
                            this.zoneBulkActionsFinish();
                        }

                    }

                    this.dispatchEvent(new CustomEvent('zoneAdd', {detail: {zone: {
                        id: zone.id,
                        name: zone.name,
                        color: zone.color,
                        geom: zone.geom,
                        vehicle_id: zone.vehicle_id
                    }}}));

                    if (this.options.grid && !this.gridData.tetris) {
                        this.gridTetrisEstimateRoutes([zone.id]);
                    }

                    resolve(zone);

                });
            } else {
                this.drawing = false;
                reject();
            }
        });
    }

    polygonOnChange(evt) {
        var mapobj, zones = {'!': 1}, points, newgeoms = {};
        var uo = this.Map.getObjectManager();
        for (var i in evt.objects) {
            mapobj = uo.objects[i];
            if (mapobj.getGeometryType() == 'Polygon') {
                points = [evt.objects[i][0].map(function(c) { for (var i in c) c[i] = Math.round(c[i]*10000000)/10000000; return c; })];
                if (points[0].length <= 3) {
                    this.polygonRemove(mapobj, true);
                    points = false;
                }
            } else {
                points = evt.objects[i];
                for (var j = points.length - 1; j >= 0; j--) {
                    if (points[j][0].length > 3) {
                        points[j][0] = points[j][0].map(function(c) { for (var i in c) c[i] = Math.round(c[i]*10000000)/10000000; return c; });
                    } else {
                        points.splice(j, 1);
                    }
                }
                if (points.length == 1) {
                    points = points[0];
                }
            }
            if (points) {
                mapobj.setPoints(points);
                if (mapobj._zone) {
                    zones[mapobj._zone] = 1;
                    newgeoms[mapobj._zone] = {type: mapobj.getGeometryType(), coordinates: JSON.parse(JSON.stringify(mapobj.points))};
                    this.zones[mapobj._zone].area = area({type: mapobj.getGeometryType(), coordinates: points}) / (1000 * 1000);
                    this.polygonAddJSTS(mapobj);
                    this.polygonSetValidityStyle(mapobj);
                    this.polygonAddLabel(mapobj);
                } else {
                    this.polygonOnAdd({object: mapobj});
                }
            }
        }
        var conflicts = this.checkValidity(Object.keys(evt.objects));
        console.log('conflicts', conflicts);
        this.stateSave();
        this.polygonClearSelection();
        this.zonesOnChange(newgeoms, conflicts);
        setTimeout(this.jobsRefresh.bind(this, zones, false, true), 0);
    }

    zonesOnChange(newgeoms, conflicts) {
        this.dispatchEvent(new CustomEvent('zonesChange', {detail: {zones: newgeoms, conflicts: conflicts}}));
        this.zonesAutoSave(newgeoms).then((() => {
            this.gridTetrisEstimateRoutes(Object.keys(newgeoms));
        }).bind(this));
    }

    zonesAutoSave(geoms) {
        return new Promise((resolve, reject) => {
            get(api).getData(
                'post',
                '/map/'+this.mapId+'/auto_save',
                {zones: geoms},
                z.any(),
                z.any()
            ).then((response) => {
                resolve(response);
            }).catch(() => {
                reject();
            });
        });
    }

    zoneGetPolygon(zone_id) {
        if (this.zones[zone_id]) {
            return this.zones[zone_id]._polygon;
        } else {
            return null;
        }
    }

    zoneGetNeighbouringPolygons(zone_id) {
        var polygons = [];
        if (this.zones[zone_id]) {
            var mapobjects = this.Map.getObjectManager().objects;
            var zonepolygon = this.zones[zone_id]._polygon;
            polygons.push(this.zones[zone_id]._polygon);
            if (!zonepolygon.isValid) {
                var bounds = zonepolygon.getBounds();
                bounds = [[bounds.minX, bounds.minY], [bounds.maxX, bounds.minY], [bounds.maxX, bounds.maxY], [bounds.minX, bounds.maxY], [bounds.minX, bounds.minY]];
                zonepolygon = {
                    id: this.zones[zone_id]._polygon.id,
                    jsts: (new GeometryFactory()).createPolygon(bounds.map(function(p) { return new Coordinate(p[0], p[1]); })),
                    isValid: true
                };
            }
            for (var i in this.polygons) {
                if (this.polygons[i].id != zonepolygon.id && this.polygons[i].id in mapobjects && zonepolygon.isValid && this.polygons[i].isValid && (zonepolygon.jsts.intersects(this.polygons[i].jsts) || zonepolygon.jsts.touches(this.polygons[i].jsts))) {
                    polygons.push(this.polygons[i]);
                }
            }
        }
        return polygons;
    }

    checkValidity(polygons) {
        if (!polygons) {
            polygons = Object.values(this.polygons);
        }
        var conflicts = []; // ZoneListConflictType[]
        var polyconflicts, i, mapobj;
        var uo = this.Map.getObjectManager();
        var checkedIntersections = {};
        for (i = 0; i < polygons.length; i++) {
            polyconflicts = {warnings: [], errors: []};
            mapobj = typeof(polygons[i]) == 'string' ? uo.objects[polygons[i]] : polygons[i];
            if (mapobj) {
                if (!mapobj.isValid) {
                    polyconflicts.errors.push({type: 'self-intersection', markable: true});
                }
                if (this.options.arealimit && this.options.arealimit < this.zones[mapobj._zone].area) {
                    polyconflicts.warnings.push({type: 'zone-too-big'});
                }
                polyconflicts = this.checkIntersections(mapobj, polyconflicts, checkedIntersections);
            } else {
                polyconflicts.errors.push({type: 'not-a-polygon'});
            }
            if (polyconflicts.warnings.length || polyconflicts.errors.length) {
                conflicts.push({poly: mapobj, zone: this.zones[mapobj._zone], conflicts: polyconflicts});
            }
        }
        return conflicts;
    }

    checkIntersections(mapobj, conflicts, checked) {
        var mapobjects = this.Map.getObjectManager().objects;
        for (var i in this.polygons) {
            if (this.polygons[i].id != mapobj.id) {
                var checkKey = [mapobj._zone, this.polygons[i]._zone];
                var reversedCheckedKey = [...checkKey].reverse().join('_');
                if (checked[reversedCheckedKey] !== undefined) {
                    if (checked[reversedCheckedKey]) {
                        conflicts.errors.push({type: 'intersection', zoneId: this.polygons[i]._zone, zoneName: this.zones[this.polygons[i]._zone].name, markable: true});
                    }
                } else {
                    var intersects = false;
                    if (this.polygons[i].id in mapobjects && mapobj.isValid && this.polygons[i].isValid && mapobj.jsts.intersects(this.polygons[i].jsts) && !mapobj.jsts.touches(this.polygons[i].jsts)) {
                        if (this.options.ingoreIntersectionsSmallerThan) {
                            var intersection = (new GeoJSONWriter()).write(mapobj.jsts.intersection(this.polygons[i].jsts));
                            if (intersection.type != 'GeometryCollection') {
                                intersection = {type: 'GeometryCollection', geometries: [intersection]};
                            }
                            intersection.geometries = intersection.geometries.filter(g => ['Polygon', 'MultiPolygon'].includes(g.type));
                            for (var j = 0, jj = intersection.geometries.length; j < jj; j++) {
                                if (area(intersection.geometries[j]) > 10) {
                                    conflicts.errors.push({type: 'intersection', zoneId: this.polygons[i]._zone, zoneName: this.zones[this.polygons[i]._zone].name, markable: true});
                                    intersects = true;
                                    break;
                                }
                            }
                        } else {
                            conflicts.errors.push({type: 'intersection', zoneId: this.polygons[i]._zone, zoneName: this.zones[this.polygons[i]._zone].name, markable: true});
                        }
                    }
                    checked[checkKey.join('_')] = intersects;
                }
            }
        }
        return conflicts;
    }

    markConflict(zoneId, conflict) {
        if (this.conflictMarker.marker) {
            if (this.conflictMarker.timeout) {
                clearTimeout(this.conflictMarker.timeout);
                this.conflictMarker.timeout = null;
            }
            this.conflictMarker.layer.remove(this.conflictMarker.marker.id);
            this.conflictMarker.marker = null;
        }
        switch (conflict.type) {
            case 'intersection':
                if (this.zones[zoneId] && conflict.zoneId && this.zones[conflict.zoneId]) {
                    try {
                        var intersection = this.zones[zoneId]._polygon.jsts.intersection(this.zones[conflict.zoneId]._polygon.jsts);
                        intersection = (new GeoJSONWriter()).write(intersection);
                        if (intersection.type != 'GeometryCollection') {
                            intersection = {type: 'GeometryCollection', geometries: [intersection]};
                        }
                        intersection.geometries = intersection.geometries.filter(g => ['Polygon', 'MultiPolygon'].includes(g.type));
                        if (intersection.geometries.length > 1) {
                            var polygons = intersection.geometries.map(g => g.type == 'Polygon' ? [g.coordinates] : g.coordinates);
                            var points = polygons.reduce((acc, val) => { acc.push(val); return acc; }, []).flat();
                        } else {
                            var points = intersection.geometries[0].coordinates;
                        }
                        this.conflictMarker.marker = new Targeo.MapObject.Polyline(points, {closed: true, zIndex: 700, interactive: false, drawStyle: [{strokeWeight: 3, strokeOpacity: 1, strokeColor: '#ff0000', fillOpacity: 0.6, fill: '#ff0000'}]});
                        this.Map.zoomToBounds(this.conflictMarker.marker.getBounds(), false, 10);
                    } catch (e) {
                        console.error(e);
                    }
                }
                break;
            case 'self-intersection':
                if (this.zones[zoneId] && !this.zones[zoneId]._polygon.isValid) {
                    var point = this.zones[zoneId]._polygon.jsts.getValidationError()._pt;
                    if (point) {
                        this.conflictMarker.marker = new Targeo.MapObject.Oval(point, 10, null, {interactive: false, visible: true, strokeWidth: 3, strokeColor: '#ff0000', fillColor: '#ff000099'});
                        this.Map.zoomAndCenter(point, Math.min(20, this.Map.getZoom()));
                    }
                }
                break;
        }
        if (this.conflictMarker.marker) {
            this.conflictMarker.phase = 'blink';
            this.conflictMarker.step = 0;
            this.conflictMarker.opacity = 0;
            this.conflictMarker.marker.setOpacity(0);
            this.conflictMarker.layer.add(this.conflictMarker.marker);
            var animConflictMarker = (function() {
                if (this.conflictMarker.marker) {
                    var timeout = null;
                    if ([0, 2, 4].includes(Math.floor(this.conflictMarker.step/10))) {
                        this.conflictMarker.opacity += 0.1;
                        timeout = this.conflictMarker.step % 10 === 9 ? 150 : 20;
                    } else if ([1, 3].includes(Math.floor(this.conflictMarker.step/10))) {
                        this.conflictMarker.opacity -= 0.1;
                        timeout = 25;
                    } else if (this.conflictMarker.step == 50) {
                        timeout = 2000;
                    } else {
                        this.conflictMarker.opacity -= 0.05;
                        if (this.conflictMarker.opacity > 0) {
                            timeout = 25;
                        } else {
                            this.conflictMarker.layer.remove(this.conflictMarker.marker.id);
                            this.conflictMarker.marker = null;
                        }
                    }
                    if (timeout) {
                        this.conflictMarker.marker.setOpacity(this.conflictMarker.opacity);
                        this.conflictMarker.step++;
                        this.conflictMarker.timeout = setTimeout(animConflictMarker, timeout);
                    }
                }
            }).bind(this);
            animConflictMarker();
        }
    }

    labelsRefresh(polygons) {
        if (!this.labelsRefreshDisabled) {
            if (!polygons) {
                polygons = this.polygons;
            }
            var resolution = this.Map.getResolution();
            var proj4326 = new proj4.Proj('EPSG:4326');
            var proj3857 = new proj4.Proj('EPSG:3857');
            var extent = this.Map.getVisibleExtent();
            extent = [proj4.transform(proj4326, proj3857, proj4.toPoint([extent.minX, extent.minY])), proj4.transform(proj4326, proj3857, proj4.toPoint([extent.maxX, extent.maxY]))];
            extent = {
                minX: extent[0].x - (extent[1].x - extent[0].x) / 2,
                minY: extent[0].y - (extent[1].y - extent[0].y) / 2,
                maxX: extent[1].x + (extent[1].x - extent[0].x) / 2,
                maxY: extent[1].y + (extent[1].y - extent[0].y) / 2
            };
            extent = [proj4.transform(proj3857, proj4326, proj4.toPoint([extent.minX, extent.minY])), proj4.transform(proj3857, proj4326, proj4.toPoint([extent.maxX, extent.maxY]))];
            extent = {minX: extent[0].x, minY: extent[0].y, maxX: extent[1].x, maxY: extent[1].y};
            var dims, centroid, i, j;
            for (i in polygons) {
                if (polygons[i].label) {
                    for (j = 0; j < polygons[i].dimensions.length; j++) {
                        dims = {w: polygons[i].dimensions[j].width / resolution, h: polygons[i].dimensions[j].height / resolution};
                        centroid = polygons[i].jsts.getGeometryN(j).getCentroid();
                        if (dims.w >= 200 && dims.h >= 100 && extent.minX <= centroid.x && extent.maxX >= centroid.x && extent.minY <= centroid.y && extent.maxY >= centroid.y) {
                            this.Map.UOShow(polygons[i].label[j].id);
                        } else {
                            this.Map.UOHide(polygons[i].label[j].id);
                        }
                    }
                }
            }
        }
    }

    stateSave(attributes) {
        console.log('stateSave', this.bulkChange, this.zonePendingActions, this.stack.length, attributes);
        if (!this.bulkChange && this.zonePendingActions.pending.length == 0 && this.zonePendingActions.bulk.length == 0) {
            var zone;
            var state = {zones: {}};
            if (attributes) {
                state.attributes = attributes;
            }
            var uo = this.Map.getObjectManager();
            for (var i in this.zones) {
                zone = this.zones[i];
                if (zone && uo.objects[zone._polygon.id]) {
                    state.zones[i] = {id: i, name: zone.name, color: zone.color, vehicle_id: zone.vehicle_id, geom: {type: zone._polygon.getGeometryType(), coordinates: JSON.parse(JSON.stringify(zone._polygon.points))}, area: zone.area, attributes: zone.attributes};
                }
            }
            this.stack.push(state);
            if (this.stack.length == 2) {
                this.dispatchEvent(new CustomEvent('stateChange', {detail: {dirty: true}}));
            }
        }
    }

    stateUpdate(zoneId) {
        var state = this.stack[this.stack.length-1];
        if (state && state.zones[zoneId]) {
            var uo = this.Map.getObjectManager();
            var zone = this.zones[zoneId];
            if (zone && uo.objects[zone._polygon.id]) {
                state.zones[zoneId] = {id: zoneId, name: zone.name, color: zone.color, vehicle_id: zone.vehicle_id, geom: {type: zone._polygon.getGeometryType(), coordinates: JSON.parse(JSON.stringify(zone._polygon.points))}, area: zone.area, attributes: zone.attributes};
            }
        }
    }

    stateUndo() {
        if (this.stack.length > 1 && !this.drawing) {
            var poly, zone;
            var poppedState = this.stack.pop();
            var state = this.stack[this.stack.length-1];
            var changed = {};
            var geomChanged = {};
            for (var i in this.zones) {
                poly = this.polygons[i];
                if (i in state.zones) {
                    if (!this.zones[i]) {
                        this.zones[i] = {id: i};
                        changed['!'] = 1;
                    }
                    zone = this.zones[i];
                    zone.name = state.zones[i].name;
                    if (zone.color != state.zones[i].color) {
                        changed[i] = 1;
                    }
                    zone.color = state.zones[i].color;
                    zone.area = state.zones[i].area;
                    zone.vehicle_id = state.zones[i].vehicle_id;
                    zone.attributes = state.zones[i].attributes;
                    zone.geom = state.zones[i].geom;
                    if (poly) {
                        if (JSON.stringify({type: poly.getGeometryType(), coordinates: poly.points}) != JSON.stringify(state.zones[i].geom)) {
                            changed[i] = 1;
                            geomChanged[i] = zone.geom;
                            poly.setPoints(state.zones[i].geom.coordinates);
                        }
                        if (changed[i]) {
                            poly.setStyle(this.polygonGetStyle('base', zone.color));
                        }
                    } else {
                        poly = this.polygonCreate(state.zones[i].geom, this.polygonGetStyle('base', this.zones[i].color));
                        poly._zone = i;
                        zone._polygon = poly;
                        this.polygons[i] = poly;
                        this.Map.UOAdd(poly);
                        if (this.editMode == 'polygon') {
                            this.Map.modules.PolygonEditor.addPolygon(poly, true);
                        }
                        geomChanged[i] = zone.geom;
                        this.dispatchEvent(new CustomEvent('zoneAdd', {detail: {zone: zone}}));
                    }
                    if (changed[i]) {
                        this.polygonAddJSTS(poly);
                        this.polygonAddLabel(poly);
                        this.polygonSetValidityStyle(poly);
                        if (this.editMode == 'grid' && this.gridData.tetris) {
                            this.gridData.tetris.zones[i].handle = this.gridTetrisCreateHandle(this.zones[i]);
                            this.gridData.tetris.zones[i].label = this.gridTetrisCreateHandleLabel(i);
                        }
                    }
                } else if (this.zones[i]) {
                    changed[i] = 1;
                    this.polygonRemove(poly, false);
                    /*this.polygonRemoveLabel(poly);
                    this.Map.UORemove(poly.id);
                    delete(this.polygons[i]);
                    //MochiKit.Signal.signal(this, 'onRemove', this.zones[i], this.pinsAvailable);
                    this.zones[i] = null;
                    if (this.editMode == 'grid' && this.gridData.tetris && this.gridData.tetris.zones[i]) {
                        this.Map.UORemove(this.gridData.tetris.zones[i].handle.id);
                        this.Map.UORemove(this.gridData.tetris.zones[i].label.id);
                        delete(this.gridData.tetris.zones[i]);
                    }*/
                }
            }
            this.zonesAutoSave(geomChanged).then((function() {
                if (this.options.grid && Object.keys(geomChanged).length > 0) {
                    this.gridTetrisEstimateRoutes(Object.keys(geomChanged));
                }
            }).bind(this));
            var polygonsChanged = [];
            var newgeoms = {};
            for (var i in geomChanged) {
                if (this.polygons[i]) {
                    polygonsChanged.push(this.polygons[i]);
                    newgeoms[i] = {type: this.polygons[i].getGeometryType(), coordinates: JSON.parse(JSON.stringify(this.polygons[i].points))};
                }
            }
            if (polygonsChanged.length) {
                var conflicts = this.checkValidity(polygonsChanged);
                this.zonesOnChange(newgeoms, conflicts);
            }
            this.jobsRefresh(changed, true, true);
            if (poppedState.attributes) {
                if (this.editMode == 'grid' && poppedState.attributes.grid) {
                    var modifications = {cell_id: poppedState.attributes.grid.cell_id, zones: {}};
                    for (var i = 0; i < poppedState.attributes.grid.zones.length; i++) {
                        modifications.zones[poppedState.attributes.grid.zones[i]] = this.zones[poppedState.attributes.grid.zones[i]] ? this.zones[poppedState.attributes.grid.zones[i]].geom : null;
                    }
                    this.gridModify(modifications);
                }
            }
            if (this.stack.length == 1) {
                this.dispatchEvent(new CustomEvent('stateChange', {detail: {dirty: false}}));
            }
            this.dispatchEvent(new CustomEvent('undo'));
        }
    }

    jobInit(job) {
        let mapObj, zone, color, jsts;
        let coordkey = JSON.stringify(job.geom.coordinates);
        if (!(job.id in this.jobs) || this.jobs[job.id].coords != coordkey) {
            jsts = (new GeometryFactory()).createPoint(new Coordinate(parseFloat(job.geom.coordinates[0]), parseFloat(job.geom.coordinates[1])))
            zone = this.jobGetZone(jsts);
            color = zone ? zone.color : '#000000';
            mapObj = new Targeo.MapObject.Oval({x: job.geom.coordinates[0], y: job.geom.coordinates[1]}, 2, null, {interactive: false, zmax: 26, visible: true, strokeWidth: 0, strokeColor: color, fillColor: color});
            this.jobs[job.id] = {coords: coordkey, zone: zone, jsts: jsts, mapObject: mapObj, parcels: job.parcels, target_date: job.target_date};
        } else {
            mapObj = this.jobs[job.id].mapObject;
        }
        return mapObj;
    }

    jobGetZone(coords, returnId) {
        var zone = null;
        for (var j in this.zones) {
            if (this.zones[j] && this.zones[j]._polygon.isValid && this.zones[j]._polygon.jsts.covers(coords)) {
                zone = this.zones[j];
                break;
            }
        }
        return returnId ? (zone ? zone.id : null) : zone;
    }

    jobsRefresh(zones, force, verbose) {
        var i, ii, z, p;
        if ('length' in zones) {
            var zo = {};
            for (i = 0, ii = zones.length; i < ii; i++) {
                zo[zones[i]] = 1;
            }
            zones = zo;
        }
        var newzone, color;
        var date = new Date();
        this.Map.getObjectManager().disableRefreshing('LastMile:areaEditor');
        for (i in this.jobs) {
            newzone = true;
            if (!zones || (zones['!'] && !this.jobs[i].zone) || (this.jobs[i].zone && zones[this.jobs[i].zone.id] && (!this.zones[this.jobs[i].zone.id] || (newzone = !(this.jobs[i].zone._polygon.isValid && this.jobs[i].zone._polygon.jsts.covers(this.jobs[i].jsts))) || force))) {
                z = newzone || !this.zones[this.jobs[i].zone._id] ? this.jobGetZone(this.jobs[i].jsts) : this.jobs[i].zone;
                if (force || this.jobs[i].zone != z) {
                    if (this.jobs[i].zone) {
                        if (this.jobs[i].zone.attributes && ('volume' in this.jobs[i].zone.attributes)) {
                            if (this.jobs[i].zone.attributes.volume.jobs) {
                                this.jobs[i].zone.attributes.volume.jobs--;
                            }
                            if (this.jobs[i].parcels && this.jobs[i].zone.attributes.volume.parcels) {
                                this.jobs[i].zone.attributes.volume.parcels -= parseInt(this.jobs[i].parcels);
                            }
                            if (this.jobs[i].zone.attributes.volume.volume) {
                                this.jobs[i].zone.attributes.volume.volume -= this.getJobVolume(this.jobs[i]);
                            }
                        }
                    }
                    if (z) {
                        if (!z.attributes) {
                            z.attributes = {};
                        }
                        if (!('volume' in z.attributes)) {
                            z.attributes.volume = {};
                        }
                        if (!z.attributes.volume.jobs) {
                            z.attributes.volume.jobs = 0;
                        }
                        z.attributes.volume.jobs++;
                        if (this.jobs[i].parcels) {
                            if (!z.attributes.volume.parcels) {
                                z.attributes.volume.parcels = 0;
                            }
                            z.attributes.volume.parcels += parseInt(this.jobs[i].parcels);
                        }
                        if (!z.attributes.volume.volume) {
                            z.attributes.volume.volume = 0;
                        }
                        z.attributes.volume.volume += this.getJobVolume(this.jobs[i]);
                    }
                    this.jobs[i].zone = z;
                    color = z ? z.color : '#000000';
                    this.jobs[i].mapObject.setStyle({strokeColor: color, fillColor: color});
                }
            }
        }
        this.Map.getObjectManager().enableRefreshing('LastMile:areaEditor');
        if (!zones) {
            zones = this.zones[i];
        }
        for (i in zones) {
            if (this.zones[i]) {
                this.polygonAddLabel(this.zones[i]._polygon);
                /*if (verbose && this.zones[i].deliverylimit && this.zones[i]._deliveries > this.zones[i].deliverylimit) {
                    MochiKit.Signal.signal(this, 'onConflict', [{zone: this.zones[i], conflicts: {errors: [], warnings: [{type: 'too-many-deliveries'}]}}], false);
                }
                if (verbose && this.zones[i].parcellimit && this.zones[i]._parcels > this.zones[i].parcellimit) {
                    MochiKit.Signal.signal(this, 'onConflict', [{zone: this.zones[i], conflicts: {errors: [], warnings: [{type: 'too-many-parcels'}]}}], false);
                }*/
            }
        }
    }

    getJobVolume(job) {
        var volume = 0;
        switch (this.volumeConfig.type) {
            case 'parcels':
                if (job.parcels) {
                    volume = job.parcels;
                }
                break;
            case 'jobs':
                volume = 1;
                break;
        }
        if (this.volumeConfig.average) {
            volume /= (1 + this.volumeConfig.dateRange[1] - this.volumeConfig.dateRange[0]);
        }
        return volume;
    }

    getJobFilter() {
        var cdate = new Date();
        var dateRange = [...this.jobDateRange];
        for (var i = 0; i < dateRange.length; i++) {
            var date = new Date(cdate);
            date.setDate(cdate.getDate() + dateRange[i]);
            dateRange[i] = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
            // https://er.automapa.pl/issues/43199
            // filter.target_date.$between[i] = date.getFullYear()+'-'+('0'+(date.getMonth()+1).toString()).substring(-2)+'-'+('0'+date.getDate().toString()).substring(-2);
        }
        var filter = {};
        if (this.volumeConfig.strictDates) {
            filter = {
                '$or': [
                    {'$and': [
                        {assigned_for_date: 'not_null'},
                        {assigned_for_date: {'$date[]@>': dateRange}}
                    ]},
                    {'$and': [
                        {assigned_for_date: null},
                        {x_target_date: {'$date[][]&&': dateRange}}
                    ]}
                ]
            };
        } else {
            filter = {
                '$or': [
                    {'$and': [
                        {assigned_for_date: 'not_null'},
                        {assigned_for_date: {'$date[]@>': dateRange}}
                    ]},
                    {'$and': [
                        {assigned_for_date: null},
                        {'$or': [
                            {x_target_date: {'$date[][]&>': dateRange}},
                            {x_target_date: {'$date[][]&&': dateRange}}
                        ]}
                    ]}
                ]
            };
        }
        filter = Object.assign(filter, this.options.filterQueries || {});
        return filter;
    }

    setJobFilter(queries, force) {
        if (force || JSON.stringify(this.options.filterQueries) != JSON.stringify(queries)) {
            this.options.filterQueries = JSON.parse(JSON.stringify(queries));
            for (var i in this.zones) {
                if (this.zones[i] && this.zones[i].attributes) {
                    this.zones[i].attributes.volume = null;
                }
            }
            this.jobs = {};
            if (this.jobsLoader) {
                this.jobsLoader.setFilter(this.getJobFilter());
            }
        }
    }

    polygonEditorStart(polyids) {
        this.editMode = 'polygon';
        if (!polyids) {
            polyids = {};
            for (var i in this.polygons) {
                polyids[this.polygons[i].id] = true;
            }
        }
        this.polygonEditorListeners = [
            this.Map.modules.PolygonEditor.listen('onModifyEnd', this.polygonOnChange, false, this),
            this.Map.modules.PolygonEditor.listen('onDrawEnd', this.polygonOnAdd, false, this)
        ];
        this.Map.modules.PolygonEditor.start({
            objects: polyids,
            draw: 'polygon',
            drawStartCondition: this.polygonOnDraw.bind(this),
            sliceCondition: this.options.slice ? 'alt' : false,
            drawStyle: this.polygonGetStyle('base', '#999999'),
            contextmenu: true,
            snap: true,
            legend: this.options.slice || this.options.merge
        });
    }

    polygonEditorClose() {
        this.polygonClearSelection();
        if (this.polygonEditorListeners.length) {
            this.polygonEditorListeners.forEach((key) => { this.Map.modules.PolygonEditor.unlistenByKey(key); });
        }
        this.polygonEditorListeners = [];
        this.Map.modules.PolygonEditor.cancel();
    }

    gridModeStart() {
        if (this.editMode == 'polygon') {
            this.polygonEditorClose();
        }
        this.editMode = 'grid';
        this.gridData = {
            tilePathCells: null,
            tilePathData: null,
            revision: null,
            currentCell: null,
            selection: {cells: {}, union: null, intersects: [], mergeable: [], valid: false},
            listeners: this.gridAddListeners(),
            algorithmParams: {cells: [], vehicleCount: 10, maxRadius: 10}
        };
        this.gridDrawerPrepare();
        this.gridInit();
        this.gridLegend();
    }

    gridModeClose() {
        this.gridUnmarkMostUnbalancedZones();
        this.gridRemoveCurrentCell();
        this.gridClearSelection();
        if (this.gridData.listeners) {
            this.gridData.listeners.forEach((key) => { this.Map.unlistenByKey(key); });
        }
        if (this.options.grid.visible) {
            this.Map.tileLayerRemove('grid_cells');
        }
        if (this.options.grid.interactive) {
            this.Map.tileLayerRemove('grid_data');
        }
        this.Map.modules.Drawer.drawUnprepare();
        this.polygonEditorStart();
        this.gridLegend();
    }

    gridAddListeners() {
        var listeners = [
            this.Map.modules.Drawer.listen('onDrawStart', this.gridOnSelectionDrawStart, false, this),
            this.Map.modules.Drawer.listen('onDrawComplete', this.gridOnSelectionDrawComplete, false, this),
            this.Map.modules.Drawer.listen('onDrawAbort', this.gridOnSelectionDrawAbort, false, this)
        ];
        if (this.options.grid.interactive) {
            listeners.push(this.Map.listen('onPointerMove', this.gridOnMouseMove, false, this));
            listeners.push(this.Map.listen('onClick', this.gridOnClick, false, this));
        }
        return listeners;
    }

    gridDrawerPrepare() {
        this.Map.modules.Drawer.drawPrepare({
            type: 'Polygon',
            condition: (function(evt) {
                if (!this.gridData.drawingSelection) {
                    this.gridData.selectionDrawerEvent = evt.originalEvent;
                }
                if (!evt.originalEvent.shiftKey && evt.originalEvent.altKey && evt.originalEvent.ctrlKey) {
                    var proj4326 = new proj4.Proj('EPSG:4326');
                    var proj3857 = new proj4.Proj('EPSG:3857');
                    var coords = proj4.transform(proj3857, proj4326, proj4.toPoint([evt.coordinate[0], evt.coordinate[1]]));
                    coords = (new GeometryFactory()).createPoint(new Coordinate(coords.x, coords.y));
                    for (var z in this.zones) {
                        if (this.zones[z] && this.zones[z]._polygon.isValid && this.zones[z]._polygon.jsts.covers(coords)) {
                            this.polygonOnClick(this.zones[z]._polygon, evt);
                            return false;
                        }
                    }
                    return false;
                }
                return evt.originalEvent.button === 0 && (this.gridData.drawingSelection || evt.originalEvent.shiftKey);
            }).bind(this),
            drawStyle: [
                {
                    strokeWeight: '2px',
                    strokeColor: '#333333',
                    strokeOpacity: '0.8',
                    fill: '#ffffff77',
                    lineDash: [5, 5],
                },
            ],
            disableMap: false
        });
    }

    gridInit() {
        return new Promise(((resolve, reject) => {
            this.setBusy(true);
            get(api).getData(
                'post',
                '/micro_grid/init_map',
                {
                    ...this.gridGetDefaultAPIParams(),
                    volume: this.options.grid.volume || ''
                },
                z.any(),
                z.any()
            ).then(((response) => {
                if (response.tile_path_cells && response.tile_path_data && response.revision) {
                    this.gridData.tilePathCells = response.tile_path_cells;
                    this.gridData.tilePathData = response.tile_path_data;
                    this.gridData.revision = response.revision;
                    if (this.options.grid.visible) {
                        this.Map.tileLayerRemove('grid_cells');
                        var tileUrlCells = get(api).getApiUrl().replace(/api$/, 'tile/')+this.gridData.tilePathCells;
                        this.Map.tileLayerAdd(new Targeo.TileLayer('grid_cells', {tileUrl: tileUrlCells+this.gridData.revision+'/{z}/{x}/{y}.png', visible: true, opacity: this.options.grid.opacity, maxtries: 15, maxZoom: 23, zIndex: 2}));
                    }
                    if (this.options.grid.interactive) {
                        this.Map.tileLayerRemove('grid_data');
                        var tileUrlData = get(api).getApiUrl().replace(/api$/, 'tile/')+this.gridData.tilePathData;
                        this.gridData.dataTileLayer = new Targeo.TileLayer('grid_data', {type: 'utfgrid', tileUrl: tileUrlData+this.gridData.revision+'/{z}/{x}/{y}.json', visible: true, maxZoom: 23});
                        this.Map.tileLayerAdd(this.gridData.dataTileLayer);
                    }
                }
                this.setBusy(false);
                resolve();
            }).bind(this));
        }).bind(this));
    }

    gridGetDefaultAPIParams() {
        return {set: this.options.grid.set, map_id: this.mapId}
    }

    gridOnMouseMove(evt) {
        if (this.options.grid.quickMove && !this.gridData.drawingSelection && evt.layersData && evt.layersData['grid_data'] && evt.layersData['grid_data'].c) {
            var gridData = evt.layersData['grid_data'];
            if (!this.gridData.selection.cells[gridData.id] && gridData.move_to_zone) {
                if (!this.gridData.currentCell || this.gridData.currentCell.id != gridData.id) {
                    console.log('zoneEditor, grid', gridData.move_to_zone);
                    this.gridRemoveCurrentCell();
                    var color = '#555555';
                    if (this.zones[gridData.move_to_zone.zone_id]) {
                        color = this.zones[gridData.move_to_zone.zone_id].color;
                    }
                    this.gridData.currentCell = {
                        id: gridData.id,
                        c: gridData.c,
                        polygon: new Targeo.MapObject.Polyline(
                            gridData.c,
                            {
                                drawStyle: [{strokeColor: color, fill: color, fillOpacity: 0.7}],
                                closed: true,
                                interactive: true,
                                mouseButtonActions: {right: 'contextmenu'},
                                fGetContextMenu: this.gridContextMenu.bind(this, 'currentCell')
                            })
                    };
                    this.Map.UOAdd(this.gridData.currentCell.polygon);
                    if (gridData.move_to_zone.azimuth !== null) {
                        this.gridData.currentCell.arrow = new Targeo.MapObject.Point(
                            {x: gridData.move_to_zone.centroid[0], y: gridData.move_to_zone.centroid[1]},
                            Targeo.Base.createSVGIcon(ZoneEditor.gridMoveArrow.replace(/\{color\}/g, color)),
                            null,
                            {interactive: false, rotation: gridData.move_to_zone.azimuth}
                        );
                    } else if (gridData.move_to_zone.zone_id === 0) {
                        this.gridData.currentCell.arrow = new Targeo.MapObject.Point(
                            {x: gridData.move_to_zone.centroid[0], y: gridData.move_to_zone.centroid[1]},
                            Targeo.Base.createSVGIcon(ZoneEditor.gridRemoveIcon.replace(/\{color\}/g, color)),
                            null,
                            {interactive: false}
                        );
                    }
                    if (this.gridData.currentCell.arrow) {
                        this.Map.UOAdd(this.gridData.currentCell.arrow);
                    }
                }
                return;
            }
        }
        if (this.gridData.currentCell) {
            this.Map.UORemove(this.gridData.currentCell.polygon.id);
            if (this.gridData.currentCell.arrow) {
                this.Map.UORemove(this.gridData.currentCell.arrow.id);
            }
            this.gridData.currentCell = null;
        }
    }

    gridOnClick(evt) {
        if (!this.gridData.drawingSelection && evt.layersData && evt.layersData['grid_data'] && evt.layersData['grid_data'].c) {
            var gridData = evt.layersData['grid_data'];
            if (!evt.originalEvent.shiftKey) {
                if (evt.originalEvent.ctrlKey) {
                    if (!evt.originalEvent.altKey) {
                        /*console.log('ZoneEditor, getObjectAtPixel', evt);
                        var coords = (new GeometryFactory()).createPoint(new Coordinate(evt.coords.x, evt.coords.y));
                        for (var z in this.zones) {
                            if (this.zones[z] && this.zones[z]._polygon.isValid && this.zones[z]._polygon.jsts.covers(coords)) {
                                this.polygonOnClick(this.zones[z]._polygon, evt);
                            }
                        }
                    } else {*/
                        this.gridToggleSelection([gridData]);
                    }
                } else if (gridData.move_to_zone && typeof(gridData.move_to_zone.zone_id) == 'number') {
                    this.gridRemoveCurrentCell();
                    var modifications = {cell_id: gridData.id, zones: {}};
                    var cellJSTS = (new GeometryFactory()).createPolygon(gridData.c[0].map(function(p) { return new Coordinate(p[0], p[1]); }));
                    for (var i in this.polygons) {
                        if (i != gridData.move_to_zone.zone_id && cellJSTS.intersects(this.polygons[i].jsts) && !cellJSTS.touches(this.polygons[i].jsts)) {
                            var diff = (new GeoJSONWriter()).write(this.polygons[i].jsts.difference(cellJSTS));
                            console.log('ZoneEditor, grid, cell add, diff', diff);
                            this.polygons[i].setPoints(diff.coordinates);
                            this.polygonAddJSTS(this.polygons[i]);
                            this.polygonAddLabel(this.polygons[i]);
                            this.polygonSetValidityStyle(this.polygons[i]);
                            modifications.zones[i] = diff;
                        }
                    }
                    if (this.zones[gridData.move_to_zone.zone_id]) {
                        var polygon = this.polygons[gridData.move_to_zone.zone_id];
                        var union = (new GeoJSONWriter()).write(cellJSTS.union(polygon.jsts));
                        console.log('ZoneEditor, grid, cell add, union', union);
                        polygon.setPoints(union.coordinates);
                        this.polygonAddJSTS(polygon);
                        this.polygonAddLabel(polygon);
                        this.polygonSetValidityStyle(polygon);
                        modifications.zones[gridData.move_to_zone.zone_id] = union;
                    }
                    this.stateSave({grid: {cell_id: gridData.id, zones: Object.keys(modifications.zones)}});
                    this.gridModify(modifications);
                }
            }
        }
    }

    gridRefreshMap() {
        this.Map.tileLayerRemove('grid_data');
        return new Promise(((resolve, reject) => {
            get(api).getData(
                'post',
                '/micro_grid/refresh_map',
                this.gridGetDefaultAPIParams(),
                z.any(),
                z.any()
            ).then(((response) => {
                if (response.revision) {
                    this.gridSetTileRevision(response.revision);
                }
                resolve();
            }).bind(this));
        }).bind(this));
    }

    gridModify(modifications) {
        this.Map.tileLayerRemove('grid_data');
        this.gridRemoveCurrentCell();
        get(api).getData(
            'post',
            '/micro_grid/move_cell',
            {
                ...this.gridGetDefaultAPIParams(),
                ...modifications
            },
            z.any(),
            z.any()
        ).then(((response) => {
            if (response.revision) {
                this.gridSetTileRevision(response.revision);
            }
        }).bind(this));
    }

    gridSetTileRevision(revision) {
        this.gridData.revision = revision
        var tileUrl = get(api).getApiUrl().replace(/api$/, 'tile/')+this.gridData.tilePathData+this.gridData.revision;
        this.gridData.dataTileLayer = new Targeo.TileLayer('grid_data', {type: 'utfgrid', tileUrl: tileUrl+'/{z}/{x}/{y}.json', visible: true, maxZoom: 23});
        this.Map.tileLayerAdd(this.gridData.dataTileLayer);
    }

    gridRemoveCurrentCell() {
        if (this.gridData.currentCell) {
            this.Map.UORemove(this.gridData.currentCell.polygon.id);
            if (this.gridData.currentCell.arrow) {
                this.Map.UORemove(this.gridData.currentCell.arrow.id);
            }
        }
    }

    gridToggleSelection(cells, union) {
        this.Map.modules.ContextMenu.hide();
        this.Map.getObjectManager().disableRefreshing('LastMile:areaEditor');
        if (this.gridData.currentCell && cells.length == 1 && this.gridData.currentCell.id == cells[0].id) {
            this.gridRemoveCurrentCell();
        }
        for (var i = 0, ii = cells.length; i < ii; i++) {
            var cell = cells[i];
            if (this.gridData.selection.cells[cell.id]) {
                if (cell.c && cells.length == 1) {
                    if (this.gridData.selection.cells[cell.id].mapObject) {
                        this.Map.UORemove(this.gridData.selection.cells[cell.id].mapObject.id);
                    }
                    if (Object.keys(this.gridData.selection.cells).length > 1) {
                        var jstsPoly = (new GeometryFactory()).createPolygon(cell.c[0].map(function(p) { return new Coordinate(p[0], p[1]); }));
                        this.gridData.selection.union = this.gridData.selection.union.difference(jstsPoly);
                    } else {
                        this.gridData.selection.union = null;
                    }
                    delete(this.gridData.selection.cells[cell.id]);
                }
            } else {
                if (cell.c) {
                    if (!this.gridData.selection.overall) {
                        var color = '#555555';
                        var style = [{strokeColor: color, fill: color, fillOpacity: 0.7}];
                        style.unshift.apply(style, this.options.selectedStyle({color: color}));
                        this.gridData.selection.cells[cell.id] = {
                            mapObject: new Targeo.MapObject.Polyline(
                                cell.c,
                                {
                                    drawStyle: style,
                                    closed: true,
                                    mouseButtonActions: {
                                        right: 'contextmenu'
                                    },
                                    fGetContextMenu: this.gridContextMenu.bind(this, 'selection')
                                }
                            ),
                            coordinates: cell.c
                        };
                        this.Map.UOAdd(this.gridData.selection.cells[cell.id].mapObject);
                    } else {
                        this.gridData.selection.cells[cell.id] = true;
                    }
                    var jstsPoly = (new GeometryFactory()).createPolygon(cell.c[0].map(function(p) { return new Coordinate(p[0], p[1]); }));
                    if (this.gridData.selection.union === null) {
                        this.gridData.selection.union = jstsPoly;
                    } else {
                        this.gridData.selection.union = this.gridData.selection.union.union(jstsPoly);
                    }
                } else {
                    this.gridData.selection.cells[cell.id] = true;
                    this.gridData.selection.overall = true;
                }
            }
        }
        if (union) {
            console.log('ZoneEditor, selection, union', JSON.stringify(union));
            var jsonReader = new GeoJSONReader();
            union = jsonReader.read(union);
            console.log('ZoneEditor, selection, union', union);
            if (this.gridData.selection.union === null) {
                this.gridData.selection.union = union;
            } else {
                this.gridData.selection.union = this.gridData.selection.union.union(union);
            }
        }
        if ((this.gridData.selection.overall || Object.keys(this.gridData.selection.cells).length > 100)) {
            var unionGeoJSON = (new GeoJSONWriter()).write(this.gridData.selection.union);
            if (!this.gridData.selection.unionPolygon) {
                for (i = 0; i < this.gridData.selection.cells.length; i++) {
                    if (this.gridData.selection.cells[i].mapObject) {
                        this.Map.UORemove(this.gridData.selection.cells[cell.id].mapObject.id);
                        this.gridData.selection.cells[cell.id] = true;
                    }
                }
                var color = '#555555';
                var style = [{strokeColor: color, fill: color, fillOpacity: 0.7}];
                style.unshift.apply(style, this.options.selectedStyle({color: color}));
                this.gridData.selection.unionPolygon = new Targeo.MapObject.Polyline(unionGeoJSON.coordinates, {
                    drawStyle: style,
                    closed: true,
                    mouseButtonActions: {
                        right: 'contextmenu'
                    },
                    fGetContextMenu: this.gridContextMenu.bind(this, 'selection')
                });
                this.Map.UOAdd(this.gridData.selection.unionPolygon);
            } else {
                this.gridData.selection.unionPolygon.setPoints(unionGeoJSON.coordinates);
            }
        }
        this.Map.getObjectManager().enableRefreshing('LastMile:areaEditor');
        this.gridData.selection.valid = false;
        if (this.gridData.selection.union && this.gridData.selection.union.isValid()) {
            this.gridData.selection.valid = true;
            var geoms = this.gridData.selection.union.getNumGeometries();
            for (var i = 0; i < geoms.length; i++) {
                var polygon = this.gridData.selection.union.getGeometryN(0);
                var holes = polygon.getNumInteriorRing();
                if (holes > 0) {
                    for (h = 0; h < holes; h++) {
                        var ring = polygon.getInteriorRingN(h);
                        if (area({type: 'Polygon', coordinates: [ring.getCoordinates().map(function(c){ return [c.x, c.y]; })]}) > 100) {
                            this.gridData.selection.valid = false;
                            break;
                        }
                    }
                }
                if (!this.gridData.selection.valid) {
                    break;
                }
            }
            this.gridSetIntersections(this.gridData.selection);
        }
        console.log('ZoneEditor, gridToggleSelection, selection', Object.keys(this.gridData.selection.cells), this.gridData.selection.valid, this.gridData.selection.union, this.gridData.selection.union ? (new GeoJSONWriter()).write(this.gridData.selection.union) : null);
        if (this.gridData.selection.valid) {
            this.Map.modules.ContextMenu.activateOption('createZoneFromCells_'+this.id);
        } else {
            this.Map.modules.ContextMenu.disactivateOption('createZoneFromCells_'+this.id);
        }
    }

    gridClearSelection() {
        this.Map.modules.ContextMenu.hide();
        for (var i in this.gridData.selection.cells) {
            if (this.gridData.selection.cells[i].mapObject) {
                this.Map.UORemove(this.gridData.selection.cells[i].mapObject.id);
            }
        }
        if (this.gridData.selection.unionPolygon) {
            this.Map.UORemove(this.gridData.selection.unionPolygon.id);
        }
        this.gridData.selection = {cells: {}, valid: false, union: null};
        this.Map.modules.ContextMenu.disactivateOption('createZoneFromCells_'+this.id);
    }

    gridContextMenu(source) {
        var opts = [];
        var selection = {valid: false};
        if (source == 'selection') {
            selection = this.gridData.selection;
        } else if (this.gridData.currentCell) {
            selection.valid = true;
            selection.union = (new GeometryFactory()).createPolygon(this.gridData.currentCell.c[0].map(function(p) { return new Coordinate(p[0], p[1]); }));
            this.gridSetIntersections(selection);
        }
        if (selection.valid) {
            opts.push({
                icon: Targeo.Base.getSVGSrc('<path d="M10 15l62 -5l14 60l-30 16l-44-10Z" fill="none" stroke="#555555" stroke-width="5"/><line x1="46" y1="30" x2="46" y2="66" stroke="#555555" stroke-width="8" stroke-linecap="round"/><line x1="28" y1="48" x2="64" y2="48" stroke="#555555" stroke-width="8" stroke-linecap="round"/>', 96, 96),
                label: this.options.translateFunc('editor_grid_create_zone_from_selection'),
                active: true,
                handler: this.gridCreateZoneFromSelection.bind(this)
            });
            if (selection.mergeable.length <= 5) {
                for (var i = 0; i < selection.mergeable.length; i++) {
                    var zone = this.zones[selection.mergeable[i]];
                    if (zone) {
                        opts.push({
                            icon: Targeo.Base.getSVGSrc('<path d="M10 15l62 -5l14 60l-30 16l-44-10Z" fill="none" stroke="{color}" stroke-width="5"/><line x1="23" y1="48" x2="69" y2="48" stroke="{color}" stroke-width="8" stroke-linecap="round"/><line x1="69" y1="48" x2="48" y2="66" stroke="{color}" stroke-width="8" stroke-linecap="round"/><line x1="69" y1="48" x2="48" y2="30" stroke="{color}" stroke-width="8" stroke-linecap="round"/>'.replace(/\{color\}/g, zone.color), 96, 96),
                            label: this.options.translateFunc('editor_grid_add_selection_to_zone')+' '+(zone.name || (zone.vehicle_id && this.vehicles[zone.vehicle_id] ? this.vehicles[zone.vehicle_id].name : '')),
                            active: true,
                            handler: this.gridAddSelectionToZone.bind(this, zone.id)
                        });
                    }
                }
            }
            if (selection.properlyIntersects.length > 0) {
                opts.push({
                    icon: Targeo.Base.getSVGSrc('<path d="M10 15l62 -5l14 60l-30 16l-44-10Z" fill="none" stroke="#555555" stroke-width="5"/><line x1="28" y1="48" x2="64" y2="48" stroke="#555555" stroke-width="8" stroke-linecap="round"/>', 96, 96),
                    label: this.options.translateFunc('editor_grid_cut_out_selection_from_zones'),
                    active: true,
                    handler: this.gridRemoveSelectionFromZones.bind(this)
                });
            }
            if (Object.keys(this.gridData.selection.cells).length >= 10) {
                opts.push({
                    icon: Targeo.Base.getSVGSrc('<path d="M10 15l32 -5l14 30l-30 16l-14-10Z" fill="none" stroke="#62a025" stroke-width="5"/><path d="M54 18l14 -8l12 1l3 24l-5 20l-25 10l-3 -14l15 -8Z" fill="none" stroke="#62a025" stroke-width="5"/><path d="M17 58l9 6l18 -10l4 20l26 -10l6 10l-4 6l-14 5l-30 0l-20 -10Z" fill="none" stroke="#62a025" stroke-width="5"/>', 96, 96),
                    label: this.options.translateFunc('editor_grid_divide_into_zones')+' (beta)',
                    active: true,
                    handler: this.gridDivideSelectionIntoZones.bind(this)
                });
            }
        }
        return opts;
    }

    gridSetIntersections(selection) {
        selection.intersects = [];
        selection.properlyIntersects = [];
        selection.mergeable = [];
        for (var z in this.polygons) {
            if (selection.union.intersects(this.polygons[z].jsts)) {
                selection.intersects.push(z);
                if (!selection.union.touches(this.polygons[z].jsts)) {
                    selection.properlyIntersects.push(z);
                }
                if (this.polygons[z].jsts.covers(selection.union)) {
                    selection.valid = false;
                } else {
                    var unionWithZone = selection.union.union(this.polygons[z].jsts);
                    var mergeable = true;
                    var geoms = unionWithZone.getNumGeometries();
                    console.log('geoms', this.zones[z].color, geoms);
                    for (var i = 0; i < geoms; i++) {
                        var polygon = unionWithZone.getGeometryN(0);
                        var holes = polygon.getNumInteriorRing();
                        if (holes > 0) {
                            //var polygonarea = area({type: 'Polygon', coordinates: [polygon.getExteriorRing().getCoordinates().map(function(c){ return [c.x, c.y]; })]});
                            for (var h = 0; h < holes; h++) {
                                var ring = polygon.getInteriorRingN(h);
                                console.log('hole area', ring, area({type: 'Polygon', coordinates: [ring.getCoordinates().map(function(c){ return [c.x, c.y]; })]}));
                                if (area({type: 'Polygon', coordinates: [ring.getCoordinates().map(function(c){ return [c.x, c.y]; })]}) > 100) {
                                    mergeable = false;
                                    break;
                                }
                            }
                        }
                        if (!mergeable) {
                            break;
                        }
                    }
                    if (mergeable) {
                        selection.mergeable.push(z);
                    }
                }
            }
        }
    }

    gridCreateZoneFromSelection() {
        if (this.gridData.selection.intersects.length > 0) {
            var modifications = {
                cell_id: Object.keys(this.gridData.selection.cells),
                zones: this.gridCutOutSelectionFromIntersectingZones()
            };
            this.gridData.pendingModifications = modifications;
        }
        this.polygonAdd((new GeoJSONWriter()).write(this.gridData.selection.union));
        this.gridClearSelection();
    }

    gridAddSelectionToZone(zoneId) {
        var modifications = {cell_id: Object.keys(this.gridData.selection.cells), zones: {}};
        if (this.zones[zoneId]) {
            var polygon = this.polygons[zoneId];
            var union = (new GeoJSONWriter()).write(this.gridData.selection.union.union(polygon.jsts));
            console.log('ZoneEditor, grid, selection add, union', union);
            polygon.setPoints(union.coordinates);
            this.polygonAddJSTS(polygon);
            this.polygonAddLabel(polygon);
            this.polygonSetValidityStyle(polygon);
            modifications.zones[zoneId] = union;
            modifications.zones = Object.assign(modifications.zones, this.gridCutOutSelectionFromIntersectingZones(zoneId));
            this.stateSave({grid: {cell_id: modifications.cell_id, zones: Object.keys(modifications.zones)}});
            this.gridModify(modifications);
        }
        this.gridClearSelection();
    }

    gridRemoveSelectionFromZones() {
        if (this.gridData.selection.intersects.length > 0) {
            var modifications = {
                cell_id: Object.keys(this.gridData.selection.cells),
                zones: this.gridCutOutSelectionFromIntersectingZones()
            };
            this.stateSave({grid: {cell_id: modifications.cell_id, zones: Object.keys(modifications.zones)}});
            this.gridModify(modifications);
            this.gridClearSelection();
        }
    }

    gridCutOutSelectionFromIntersectingZones(excludeZoneId) {
        var newZoneGeometries = {};
        for (var i = 0; i < this.gridData.selection.intersects.length; i++) {
            var zone = this.zones[this.gridData.selection.intersects[i]];
            if (zone && (!excludeZoneId || zone.id != excludeZoneId) && this.gridData.selection.union.intersects(this.polygons[zone.id].jsts) && !this.gridData.selection.union.touches(this.polygons[zone.id].jsts)) {
                var diff = (new GeoJSONWriter()).write(this.polygons[zone.id].jsts.difference(this.gridData.selection.union));
                console.log('ZoneEditor, grid, selection add, diff', diff);
                this.polygons[zone.id].setPoints(diff.coordinates);
                this.polygonAddJSTS(this.polygons[zone.id]);
                this.polygonAddLabel(this.polygons[zone.id]);
                this.polygonSetValidityStyle(this.polygons[zone.id]);
                newZoneGeometries[zone.id] = diff;
            }
        }
        return newZoneGeometries;
    }

    gridDivideSelectionIntoZones() {
        this.gridAlgorithmRun({
            mode: 'create',
            gridSet: this.options.grid.set,
            mapId: this.mapId,
            attribute: "attributes->'"+this.options.grid.volume.replace(/\./g, "'->'")+"'->>'value'",
            cells: Object.keys(this.gridData.selection.cells),
            showParamWindow: true
        });
        this.polygonClearSelection();
    }

    gridOnSelectionDrawStart(evt) {
        console.log('gridOnSelectionDrawStart', this.gridData.selectionDrawerEvent);
        if (!this.gridData.selectionDrawerEvent.ctrlKey) {
            this.gridClearSelection();
        }
        this.gridData.drawingSelection = true;
        this.gridRemoveCurrentCell();
    }

    gridOnSelectionDrawAbort(evt) {
        this.gridData.drawingSelection = false;
    }

    gridOnSelectionDrawComplete(evt) {
        this.gridData.drawingSelection = false;
        if (evt.coords.length >= 3) {
            var coords = evt.coords.map(p => [p.x, p.y]);
            coords.push(coords[0]);
            if (this.gridData.selectionDrawerEvent.altKey) {
                var selectionJSTS = (new GeometryFactory()).createPolygon(coords.map(function(p) { return new Coordinate(p[0], p[1]); }));
                for (var zoneId in this.polygons) {
                    if (this.polygons[zoneId].jsts.intersects(selectionJSTS)) {
                        var intersection = this.polygons[zoneId].jsts.intersection(selectionJSTS);
                        intersection = (new GeoJSONWriter()).write(intersection);
                        console.log('zoneEditor, gridOnSelectionDrawComplete, intersection', intersection, area(intersection), this.zones[zoneId].area);
                        if (area(intersection) / (1000 * 1000) >= this.zones[zoneId].area * 0.5) {
                            console.log('zoneEditor, gridOnSelectionDrawComplete, addZoneToSelection', this.zones[zoneId].name);
                            if (!this.polygons[zoneId]._selected) {
                                this.polygonToggleSelection(this.polygons[zoneId]);
                            }
                        }
                    }
                }
            } else {
                get(api).getData(
                    'post',
                    '/micro_grid/select',
                    {
                        ...this.gridGetDefaultAPIParams(),
                        geom: {type: 'Polygon', coordinates: [coords]}
                    },
                    z.any(),
                    z.any()
                ).then(((response) => {
                    if (response.cells) {
                        this.gridToggleSelection(response.cells.map(c => typeof(c) == 'number' ? {id: c} : c), response.geom || null);
                        /*for (var i = 0; i < response.cells.length; i++) {
                            if (!this.gridData.selection.cells[response.cells[i].id]) {
                                this.gridToggleSelection(response.cells[i]);
                            }
                        }*/
                    }
                }).bind(this));
            }
        }
    }

    gridAlgorithmRun(params) {
        return new Promise(((resolve, reject) => {
            if (params.showParamWindow) {
                var props = Object.assign(this.gridData.gridAlgorithmParams || {}, {
                    mode: params.mode,
                    cells: params.cells,
                    gridSet: params.gridSet,
                    mapId: params.mapId,
                    zoneIds: params.zoneIds,
                    vehicleCount: params.vehicleCount || 7,
                    attribute: params.attribute,
                    ignoreMapping: 'ignoreMapping' in params ? params.ignoreMapping : true,
                    onProceed: async (params) => {
                        await this.gridAlgorithmRequest(params);
                        return true;
                    }
                });
                openModal(ModalGridAlgorithmParams, props);
            } else {
                this.setBusy(true);
                if (!params.maxLoad) {
                    get(api).getData(
                        'post',
                        '/micro_grid/get_total_volume',
                        {
                            gridSet: params.gridSet,
                            cells: params.cells,
                            zoneIds: params.zoneIds,
                            attribute: params.attribute
                        },
                        z.any(),
                        z.any()
                    ).then(((response) => {
                        if (response.cells) {
                            params.cells = response.cells;
                        }
                        if (typeof(response.total) == 'number') {
                            params.maxLoad = response.total;
                        }
                        this.gridAlgorithmRequest(params).then((response) => {
                            this.setBusy(false);
                            resolve();
                        });
                    }).bind(this));
                } else {
                    this.gridAlgorithmRequest(params).then((response) => {
                        this.setBusy(false);
                        resolve();
                    });
                }
            }
        }).bind(this));
    }

    gridAlgorithmRequest(params) {
        this.gridData.algorithmParams = params;
        console.log('zoneEditor, gridAlgorithmRequest', params);
        return new Promise(((resolve, reject) => {
            get(api).getData(
                'post',
                '/micro_grid/run_operation',
                params,
                z.any(),
                z.any()
            ).then(((response) => {
                this.gridParseAlgorithmResponse(response).then(() => { resolve(); });
            }).bind(this));
        }).bind(this));
    }

    gridParseAlgorithmResponse(response) {
        console.log('zoneEditor, gridParseAlgorithmResponse', response);
        return new Promise(((resolve, reject) => {
            if (response && response.status == 'ok') {
                if (response.zones) {
                    this.gridClearSelection();
                    this.zoneBulkActionInit('gridAlgorithm');
                    let polygonsChanged = [];
                    let newgeoms = {};
                    for (let i = 0; i < response.zones.length; i++) {
                        if (response.zones[i]) {
                            if (response.zones[i].properties?.zone) {
                                let zoneId = response.zones[i].properties?.zone;
                                delete(response.zones[i].properties);
                                this.zoneChangeGeometry(zoneId, response.zones[i]);
                                let polygon = this.zoneGetPolygon(zoneId);
                                polygonsChanged.push(polygon);
                                newgeoms[zoneId] = {type: polygon.getGeometryType(), coordinates: JSON.parse(JSON.stringify(polygon.points))};
                            } else {
                                this.polygonAdd(response.zones[i], null);
                            }
                        }
                    }
                    if (this.gridData.algorithmParams.mode == 'partition') {
                        this.zoneRemove(this.gridData.algorithmParams.partitionedZoneId);
                    }
                    var zonesToRefresh = Object.keys(newgeoms);
                    zonesToRefresh.push('!');
                    this.jobsRefresh(zonesToRefresh);
                    this.zoneBulkActionComplete('gridAlgorithm');
                    let conflicts = this.checkValidity(polygonsChanged);
                    this.zonesOnChange(newgeoms, conflicts);
                    this.gridUpdateZonesVolume().then((() => {
                        this.gridTetrisEstimateRoutes(Object.keys(response.zones));
                        this.gridRefreshMap().then((() => {
                            resolve();
                        }).bind(this));
                    }).bind(this));
                }
            }
        }).bind(this));
    }

    gridBalanceZones(zones) {
        this.setBusy(true);
        if (!zones) {
            var zones = Object.values(this.selection.polygons).map(p => p._zone);
        }
        this.polygonClearSelection();
        this.Map.tileLayerRemove('grid_data');
        get(api).getData(
            'post',
            '/micro_grid/balance_zones',
            {
                ...this.gridGetDefaultAPIParams(),
                volume: this.options.grid.volume,
                zones: zones
            },
            z.any(),
            z.any()
        ).then(this.onGridZoneModifyOperation.bind(this));
    }

    gridPartitionZone(obj) {
        this.setBusy(true);
        var zone = obj._zone;
        var participants = Object.values(this.selection.polygons).map(p => p._zone).filter(z => z != zone);
        this.polygonClearSelection();
        this.Map.tileLayerRemove('grid_data');
        get(api).getData(
            'post',
            '/micro_grid/partition_zone',
            {
                ...this.gridGetDefaultAPIParams(),
                volume: this.options.grid.volume,
                zone: zone,
                participants: participants
            },
            z.any(),
            z.any()
        ).then(this.onGridZoneModifyOperation.bind(this));
    }

    onGridZoneModifyOperation(response) {
        console.log('ZoneEditor, onGridZoneModifyOperation', response);
        if (response.zones) {
            var zone, polygon;
            var newgeoms = {};
            for (var zoneId in response.zones) {
                zone = this.zones[zoneId];
                if (zone) {
                    if (!zone.attributes) {
                        zone.attributes = {};
                    }
                    zone.attributes.volume = response.zones[zoneId].volume;
                    polygon = zone._polygon;
                    if (response.zones[zoneId].geom) {
                        polygon.setPoints(response.zones[zoneId].geom.coordinates);
                        newgeoms[zoneId] = {type: polygon.getGeometryType(), coordinates: JSON.parse(JSON.stringify(polygon.points))};
                        this.zones[zoneId].area = area({type: polygon.getGeometryType(), coordinates: response.zones[zoneId].geom.coordinates}) / (1000 * 1000);
                        this.polygonAddJSTS(polygon);
                        this.polygonSetValidityStyle(polygon);
                        this.polygonAddLabel(polygon);
                    } else {
                        this.polygonRemove(polygon, false);
                    }
                }
            }
            this.zonesOnChange(newgeoms, []);
            var stateAttributes = {grid: {cell_id: response.cells, zones: Object.keys(response.zones)}};
            this.stateSave(stateAttributes);
            this.jobsRefresh(Object.keys(response.zones));
            if (response.revision) {
                this.gridSetTileRevision(response.revision);
            }
        }
        this.setBusy(false);
    }

    gridBalanceZones2(zones) {
        if (!zones) {
            var zones = Object.values(this.selection.polygons).map(p => p._zone);
        }
        this.polygonClearSelection();
        return new Promise(((resolve, reject) => {
            this.gridAlgorithmRun({
                mode: 'balance',
                gridSet: this.options.grid.set,
                mapId: this.mapId,
                attribute: "attributes->'"+this.options.grid.volume.replace(/\./g, "'->'")+"'->>'value'",
                cells: [],
                zoneIds: zones,
                vehicleCount: zones.length,
                ignoreMapping: false,
                maxRadius: 100,
                showParamWindow: false
            }).then((function() {
                resolve();
            }).bind(this)).catch(reject);
        }).bind(this));
    }

    gridPartitionZone2(obj) {
        var zones = Object.values(this.selection.polygons).map(p => p._zone);
        this.polygonClearSelection();
        if (zones.length == 1) {
            for (var i in this.polygons) {
                if (this.polygons[i]._zone != zones[0] && obj.jsts.intersects(this.polygons[i].jsts)) {
                    zones.push(this.polygons[i]._zone);
                }
            }
        }
        this.gridAlgorithmRun({
            mode: 'partition',
            gridSet: this.options.grid.set,
            mapId: this.mapId,
            attribute: "attributes->'"+this.options.grid.volume.replace(/\./g, "'->'")+"'->>'value'",
            cells: [],
            zoneIds: zones,
            partitionedZoneId: obj._zone,
            vehicleCount: zones.length - 1,
            ignoreMapping: false,
            maxRadius: 100,
            showParamWindow: false
        });
    }

    gridSetVolume(volume) {
        this.volumeConfig = volume;
        this.jobDateRange = volume.dateRange;
        this.setJobFilter(this.options.filterQueries, true);
        /*if (this.jobsLoader) {
            this.jobsLoader.setFilter(this.getJobFilter());
        }*/
        this.setBusy(true);
        return new Promise(((resolve, reject) => {
            get(api).getData(
                'post',
                '/micro_grid/set_volume',
                {
                    ...this.gridGetDefaultAPIParams(),
                    volume: volume,
                    filter: this.options.filterQueries || {}
                },
                z.any(),
                z.any()
            ).then(((response) => {
                if (response.volume) {
                    this.options.grid.volume = response.volume;
                    this.gridUpdateZonesVolume().then((() => {
                        this.gridTetrisEstimateRoutes(Object.keys(this.zones));
                        this.setBusy(false);
                        resolve();
                    }).bind(this));
                    if (this.editMode == 'grid') {
                        this.Map.tileLayerRemove('grid_cells');
                        this.Map.tileLayerRemove('grid_data');
                        get(api).getData(
                            'post',
                            '/micro_grid/get_tile_paths',
                            {
                                ...this.gridGetDefaultAPIParams(),
                                volume: this.options.grid.volume || ''
                            },
                            z.any(),
                            z.any()
                        ).then(((response) => {
                            if (response.tile_path_cells && response.tile_path_data && response.revision) {
                                this.gridData.tilePathCells = response.tile_path_cells;
                                this.gridData.tilePathData = response.tile_path_data;
                                this.gridData.revision = response.revision;
                                if (this.options.grid.visible) {
                                    var tileUrlCells = get(api).getApiUrl().replace(/api$/, 'tile/')+this.gridData.tilePathCells;
                                    this.Map.tileLayerAdd(new Targeo.TileLayer('grid_cells', {tileUrl: tileUrlCells+this.gridData.revision+'/{z}/{x}/{y}.png', visible: true, opacity: this.options.grid.opacity, maxtries: 15, maxZoom: 23, zIndex: 2}));
                                }
                                if (this.options.grid.interactive) {
                                    var tileUrlData = get(api).getApiUrl().replace(/api$/, 'tile/')+this.gridData.tilePathData;
                                    this.gridData.dataTileLayer = new Targeo.TileLayer('grid_data', {type: 'utfgrid', tileUrl: tileUrlData+this.gridData.revision+'/{z}/{x}/{y}.json', visible: true, maxZoom: 23});
                                    this.Map.tileLayerAdd(this.gridData.dataTileLayer);
                                    this.gridData.listeners.push(this.Map.listen('onPointerMove', this.gridOnMouseMove, false, this));
                                    this.gridData.listeners.push(this.Map.listen('onClick', this.gridOnClick, false, this));
                                }
                            }
                        }).bind(this));
                    }
                } else {
                    reject();
                }
            }).bind(this));
        }).bind(this));
    }

    gridUpdateZonesVolume() {
        return new Promise(((resolve, reject) => {
            get(api).getData(
                'post',
                '/micro_grid/set_volume_for_zones',
                {
                    ...this.gridGetDefaultAPIParams(),
                    volume: this.options.grid.volume
                },
                z.any(),
                z.any()
            ).then(((volume) => {
                var zoneIds = Object.keys(volume);
                for (var zoneId in volume) {
                    if (this.zones[zoneId]) {
                        if (!this.zones[zoneId].attributes) {
                            this.zones[zoneId].attributes = {};
                        }
                        this.zones[zoneId].attributes.volume = volume[zoneId];
                        console.log('zoneEditor, gridUpdateZonesVolume', zoneId, this.zones[zoneId].attributes.volume);
                        this.polygonAddLabel(this.polygons[zoneId]);
                    } else {
                        console.log('zoneEditor, gridUpdateZonesVolume, zone does not exist', zoneId);
                    }
                }
                resolve();
            }).bind(this));
        }).bind(this));
    }

    gridMarkMostUnbalancedZones(onBalance) {
        var checkedPairs = {};
        var max = null;
        for (var i in this.zones) {
            if (this.zones[i]) {
                for (var j in this.zones) {
                    if (i != j && typeof(checkedPairs[j+'_'+i]) !== 'number' && this.zones[j] && this.zones[i]._polygon.jsts.intersects(this.zones[j]._polygon.jsts)) {
                        var vol1 = this.zones[i].attributes && this.zones[i].attributes.volume ? this.zones[i].attributes.volume.volume : 0;
                        var vol2 = this.zones[j].attributes && this.zones[j].attributes.volume ? this.zones[j].attributes.volume.volume : 0;
                        checkedPairs[i+'_'+j] = Math.abs(vol1 - vol2);
                        if ((!max || max.value < Math.abs(vol1 - vol2)) && (!this.gridData.mostUnbalancedZonesMarker || this.gridData.mostUnbalancedZonesMarker.zones.intersection(new Set([i, j])).size < 2)) {
                            max = {value: Math.abs(vol1 - vol2), zones: [i, j], volumes: [vol1, vol2]};
                        }
                    }
                }
            }
        }
        if (max && max.value >= 5) {
            var intersection = this.zones[max.zones[0]]._polygon.jsts.intersection(this.zones[max.zones[1]]._polygon.jsts);
            var centroid = intersection.getCentroid();
            var centroidGeom = (new GeometryFactory()).createPoint(new Coordinate(centroid.x, centroid.y));
            if (!intersection.covers(centroidGeom)) {
                var distanceOp = new DistanceOp(intersection, centroidGeom);
                var closestPoints = distanceOp.nearestPoints();
                centroid = closestPoints[0];
            }
            if (max.volumes[0] > max.volumes[1]) {
                max.volumes = max.volumes.reverse();
                max.zones = max.zones.reverse();
            };
            var zoneCentroids = max.zones.map(z => this.zones[z]._polygon.jsts.getCentroid());
            var angle = Math.atan2(zoneCentroids[1].y - zoneCentroids[0].y, zoneCentroids[1].x - zoneCentroids[0].x);
            var bounds = null;
            var zoomToZones = [...max.zones];
            if (this.gridData.mostUnbalancedZonesMarker) {
                zoomToZones = zoomToZones.concat(Array.from(this.gridData.mostUnbalancedZonesMarker.zones));
            }
            for (i = 0; i < zoomToZones.length; i++) {
                var polybounds = this.zones[zoomToZones[i]]._polygon.getBounds();
                if (!bounds) {
                    bounds = polybounds;
                } else {
                    bounds = {minX: Math.min(bounds.minX, polybounds.minX), minY: Math.min(bounds.minY, polybounds.minY), maxX: Math.max(bounds.maxX, polybounds.maxX), maxY: Math.max(bounds.maxY, polybounds.maxY)};
                }
            }
            var currentMapExtent = this.Map.getVisibleExtent();
            if (currentMapExtent.minX > bounds.minX || currentMapExtent.minY > bounds.minY || currentMapExtent.maxX < bounds.maxX || currentMapExtent.maxY < bounds.maxY) {
                this.Map.zoomToBounds(bounds, true, 10, {zmin: this.Map.getZoom()});
            }
            console.log('balance (label)', this.gridCreateUnbalancedZonesMarkerLabel(max.zones, max.value, '#0000ff'));
            this.gridData.mostUnbalancedZonesMarker = {
                ...(this.gridData.mostUnbalancedZonesMarker || {}),
                centroid: centroid,
                zones: new Set(max.zones),
                point: new Targeo.MapObject.Point(
                    {x: centroid.x, y: centroid.y},
                    Targeo.Base.createSVGIcon(ZoneEditor.gridZoneBalanceMarker.replace('{color}', '#0000ff'), 40, 40, 20, 20),
                    null,
                    {
                        rotation: -angle,
                        mouseButtonActions: {left: (this.gridBalanceMostUnbalancedZones).bind(this)}
                    }
                ),
                label: new Targeo.MapObject.DOM(
                    {x: centroid.x, y: centroid.y},
                    this.gridCreateUnbalancedZonesMarkerLabel(max.zones, max.value, '#0000ff'),
                    null,
                    {
                        valign: 'top',
                        offset: {x: 0, y: -21}
                    }
                )
            };
            if (onBalance && !this.gridData.mostUnbalancedZonesMarker.onBalance) {
                this.gridData.mostUnbalancedZonesMarker.onBalance = onBalance;
            }
            this.Map.UOAdd(this.gridData.mostUnbalancedZonesMarker.point);
            this.Map.UOAdd(this.gridData.mostUnbalancedZonesMarker.label);
            if (typeof(this.gridData.mostUnbalancedZonesMarker.onBalance) == 'function') {
                this.gridData.mostUnbalancedZonesMarker.onBalance('onMark');
            }
        } else {
            if (!this.gridData.mostUnbalancedZonesMarker) {
                openModal(ModalInfo, {text: this.options.translateFunc('editor_grid_balance_no_unbalanced_zones')});
            }
            this.gridUnmarkMostUnbalancedZones();
        }
    }

    gridCreateUnbalancedZonesMarkerLabel(zones, value, color) {
        console.log('zoneEditor, gridCreateUnbalancedZonesMarkerLabel', zones, value, color);
        var label =
            ('<div style="text-align: center; color: #ffffff; background-color: '+color+'; border: 3px solid #ffffff; border-radius: 5px; padding: 3px 5px; opacity: 0.8">'
                +(
                    this.zones[zones[0]].name && this.zones[zones[1]].name
                        ? '<div style="display: flex; margin-bottom: 2px; font-size: 11px">'
                            +'<div style="background-color: #ffffff; color: '+color+'; padding: 1px 3px">'
                            +this.zones[zones[0]].name
                            +'</div>'
                            +'<div style="width: 0; height: 0; border-top: 8px solid transparent; border-bottom: 8px solid transparent; border-left: 5px solid #ffffff;"></div>'
                            +'<div style="padding: 1px 3px">'
                            +this.zones[zones[1]].name
                            +'</div>'
                          +'</div>'
                        : '')
                +'<div><span style="font-size: 10px">Δ</span> <span style="font-weight: 600; font-size: 15px">'+(Math.round(100*value)/100).toLocaleString()+'</span></div>'
            +'</div>');
        return label;
    }

    gridBalanceMostUnbalancedZones() {
        this.gridBalanceZones2(Array.from(this.gridData.mostUnbalancedZonesMarker.zones)).then(() => {
            if (this.gridData.mostUnbalancedZonesMarker.previousPoint) {
                this.Map.UORemove(this.gridData.mostUnbalancedZonesMarker.previousPoint.id);
                this.Map.UORemove(this.gridData.mostUnbalancedZonesMarker.previousLabel.id);
            }
            this.gridData.mostUnbalancedZonesMarker.point.setIcon(Targeo.Base.createSVGIcon(ZoneEditor.gridZoneBalanceMarker.replace('{color}', '#016e2b'), 40, 40, 20, 20));
            this.gridData.mostUnbalancedZonesMarker.previousPoint = this.gridData.mostUnbalancedZonesMarker.point;
            this.gridData.mostUnbalancedZonesMarker.previousPoint.setInteractive(false);
            var prevVolumes = Array.from(this.gridData.mostUnbalancedZonesMarker.zones).map((z) => this.zones[z].attributes && this.zones[z].attributes.volume ? this.zones[z].attributes.volume.volume : 0);
            this.gridData.mostUnbalancedZonesMarker.previousLabel = new Targeo.MapObject.DOM(
                {x: this.gridData.mostUnbalancedZonesMarker.centroid.x, y: this.gridData.mostUnbalancedZonesMarker.centroid.y},
                this.gridCreateUnbalancedZonesMarkerLabel(Array.from(this.gridData.mostUnbalancedZonesMarker.zones), Math.abs(prevVolumes[0]-prevVolumes[1]), '#016e2b'),
                null,
                {
                    valign: 'top',
                    offset: {x: 0, y: -21},
                    interactive: false
                }
            );
            this.Map.UOAdd(this.gridData.mostUnbalancedZonesMarker.previousLabel);
            this.Map.UORemove(this.gridData.mostUnbalancedZonesMarker.label.id);
            if (typeof(this.gridData.mostUnbalancedZonesMarker.onBalance) == 'function') {
                this.gridData.mostUnbalancedZonesMarker.onBalance('onBalance');
            }
            this.gridMarkMostUnbalancedZones();
        });
    }

    gridUnmarkMostUnbalancedZones() {
        if (this.gridData.mostUnbalancedZonesMarker) {
            if (typeof(this.gridData.mostUnbalancedZonesMarker.onBalance) == 'function') {
                this.gridData.mostUnbalancedZonesMarker.onBalance('onUnmark');
            }
            if (this.gridData.mostUnbalancedZonesMarker.previousPoint) {
                this.Map.UORemove(this.gridData.mostUnbalancedZonesMarker.previousPoint.id);
                this.Map.UORemove(this.gridData.mostUnbalancedZonesMarker.previousLabel.id);
            }
            this.Map.UORemove(this.gridData.mostUnbalancedZonesMarker.point.id);
            this.Map.UORemove(this.gridData.mostUnbalancedZonesMarker.label.id);
            this.gridData.mostUnbalancedZonesMarker = null;
        }
    }

    gridSnapZones() {
        this.setBusy(true);
        this.Map.tileLayerRemove('grid_data');
        get(api).getData(
            'post',
            '/micro_grid/snap_zones',
            {
                ...this.gridGetDefaultAPIParams()
            },
            z.any(),
            z.any()
        ).then(((response) => {
            if (response.zones) {
                this.gridClearSelection();
                this.zoneBulkActionInit('gridSnapZones');
                var modifiedZones = {};
                for (var i in response.zones) {
                    if (response.zones[i]) {
                        if (JSON.stringify(response.zones) != JSON.stringify(this.zones[i].geom)) {
                            modifiedZones[i] = response.zones[i];
                            this.zoneChangeGeometry(i, response.zones[i]);
                        }
                    }
                }
                this.zoneBulkActionComplete('gridSnapZones');
                this.zonesOnChange(modifiedZones, this.checkValidity());
                this.jobsRefresh(Object.keys(response.zones));
                /*if (response.revision) {
                    this.gridSetTileRevision(response.revision);
                }*/
                this.gridUpdateZonesVolume().then((() => {
                    this.gridTetrisEstimateRoutes(Object.keys(response.zones));
                    this.gridRefreshMap().then((() => {
                        this.setBusy(false);
                    }).bind(this));
                }).bind(this));
            } else {
                this.setBusy(false);
            }
        }).bind(this));
    }

    gridTetrisModeStart() {
        this.gridRemoveCurrentCell();
        this.gridClearSelection();
        if (this.gridData.listeners) {
            this.gridData.listeners.forEach((key) => { this.Map.unlistenByKey(key); });
        }
        if (this.options.grid.interactive) {
            this.Map.tileLayerRemove('grid_data');
        }
        this.Map.modules.Drawer.drawUnprepare();
        this.gridData.tetris = {zones: {}};
        var getRouteEstimates = [];
        for (var z in this.zones) {
            if (this.zones[z]) {
                console.log('ZoneEditor, gridTetrisModeStart, zone', this.zones[z].name, this.zones[z].attributes);
                if (this.zones[z].attributes && this.zones[z].attributes.tetris) {
                    this.gridData.tetris.zones[z] = {
                        coords: this.zones[z].attributes.tetris.root,
                        maxLoad: this.zones[z].attributes.tetris.maxLoad,
                        maxRadius: 30000,
                        locked: this.zones[z].attributes.tetris.locked
                    };
                } else {
                    var root = this.polygons[z].jsts.getInteriorPoint();
                    this.gridData.tetris.zones[z] = {
                        coords: {x: root.x, y: root.y},
                        maxLoad: this.zones[z].attributes.volume.volume,
                        maxRadius: 30000,
                        locked: true
                    };
                    this.zones[z].attributes.tetris = JSON.parse(JSON.stringify(this.gridData.tetris.zones[z]));
                    this.zones[z].attributes.tetris.root = this.zones[z].attributes.tetris.coords;
                    delete(this.zones[z].attributes.tetris.coords);
                    this.stateUpdate(z);
                }
                this.gridData.tetris.zones[z].handle = this.gridTetrisCreateHandle(this.zones[z]);
                this.gridData.tetris.zones[z].label = this.gridTetrisCreateHandleLabel(z);
                getRouteEstimates.push(z);
                this.polygonSetLabelOpacity(this.zones[z]._polygon);
            }
        }
        this.gridTetrisEstimateRoutes(getRouteEstimates);
        this.gridData.tetris.clickListener = this.Map.listen('onClick', function(e) {
            var proj4326 = new proj4.Proj('EPSG:4326');
            var proj3857 = new proj4.Proj('EPSG:3857');
            var clickCoords = proj4.transform(proj4326, proj3857, proj4.toPoint([e.coords.x, e.coords.y]));
            var resolution = this.Map.getResolution();
            for (var z in this.gridData.tetris.zones) {
                var zoneRoot = proj4.transform(proj4326, proj3857, proj4.toPoint([this.gridData.tetris.zones[z].coords.x, this.gridData.tetris.zones[z].coords.y]));
                var distance = Math.sqrt(Math.pow(clickCoords.x - zoneRoot.x, 2) + Math.pow(clickCoords.y - zoneRoot.y, 2)) / resolution;
                if (distance < 20) {
                    return;
                }
            }
            this.gridTetrisAddZone(e.coords);
        }, false, this);
        this.gridLegend();
        Targeo.Base.addCSSs({
            '.grid-tetris-balloon': 'font: inherit; display: flex; flex-direction: column; gap: 5px; align-items: center;',
            '.grid-tetris-balloon button': 'background-color: #ddd; font: inherit; font-size: 14px; color: #555;',
            '.grid-tetris-balloon .buttons.increment button': 'border: 1px solid #aaa; border-left: 0; border-top-right-radius: 4px; border-bottom-right-radius: 4px; margin-left: -4px; padding: 2px 4px 2px 8px',
            '.grid-tetris-balloon .buttons.decrement button': 'border: 1px solid #aaa; border-right: 0; border-top-left-radius: 4px; border-bottom-left-radius: 4px; margin-right: -4px; padding: 2px 8px 2px 4px',
            '.grid-tetris-balloon input': 'border: 1px solid #aaa; border-radius: 4px; padding: 5px 7px; background-color: #fff; font: inherit; font-size: 14px;'
        });
    }

    gridTetrisModeStop() {
        return new Promise(((resolve, reject) => {
            this.Map.unlistenByKey(this.gridData.tetris.clickListener);
            for (var z in this.gridData.tetris.zones) {
                this.Map.UORemove(this.gridData.tetris.zones[z].handle.id);
                this.Map.UORemove(this.gridData.tetris.zones[z].label.id);
            }
            /*if (this.options.grid.interactive) {
                this.Map.tileLayerAdd(this.gridData.dataTileLayer);
            }*/
            this.gridDrawerPrepare();
            this.gridData.tetris = null;
            for (z in this.zones) {
                if (this.zones[z]) {
                    this.polygonSetLabelOpacity(this.zones[z]._polygon);
                }
            }
            this.gridData.listeners = this.gridAddListeners();
            this.gridLegend();
            this.gridInit().then(()=>{resolve();});
        }).bind(this));
    }

    gridTetrisAddZone(coords) {
        var limits = Object.values(this.vehicles).map((v) => v.parcel_limit).filter((l) => l);
        this.gridData.tetris.zones._new = {
            coords: coords,
            maxLoad: Math.round(limits.reduce((acc, val) => acc + val, 0) / limits.length),
            maxRadius: 30000,
            locked: false
        };
        this.gridTetrisRun();
    }

    gridTetrisRun() {
        var bricks = {};
        var props = ['coords', 'maxLoad', 'maxRadius', 'locked'];
        Object.keys(this.gridData.tetris.zones).forEach((function(z) {
            if (!this.gridData.tetris.zones[z].locked) {
                bricks[z] = {}
                for (var i = 0; i < props.length; i++) bricks[z][props[i]] = this.gridData.tetris.zones[z][props[i]];
            }
        }).bind(this));
        this.setBusy(true);
        get(api).getData(
            'post',
            '/micro_grid/tetris',
            {
                gridSet: this.options.grid.set,
                mapId: this.mapId,
                attribute: "attributes->'"+this.options.grid.volume.replace(/\./g, "'->'")+"'->>'value'",
                bricks: bricks
            },
            z.any(),
            z.any()
        ).then(((response) => {
            if (response.zones) {
                this.zoneBulkActionInit('gridTetrisRun');
                var newZones = 0;
                var updatedZones = {'!': 1};
                for (var z in response.zones) {
                    if (this.zones[z]) {
                        this.zoneChangeGeometry(z, response.zones[z]);
                        updatedZones[z] = 1;
                    } else {
                        newZones++;
                        var mapobj = this.polygonCreate(response.zones[z]);
                        this.polygonOnAdd({object: mapobj}).then(((zone) => {
                            console.log('ZoneEditor, tetris, new zone', zone);
                            this.Map.UOAdd(mapobj);
                            this.gridData.tetris.zones[zone.id] = bricks[z];
                            if (!zone.attributes) {
                                zone.attributes = {};
                            }
                            zone.attributes.tetris = {
                                root: this.gridData.tetris.zones[zone.id].coords,
                                maxLoad: this.gridData.tetris.zones[zone.id].maxLoad,
                                locked: this.gridData.tetris.zones[zone.id].locked
                            };
                            this.gridData.tetris.zones[zone.id].handle = this.gridTetrisCreateHandle(zone);
                            this.gridData.tetris.zones[zone.id].label = this.gridTetrisCreateHandleLabel(zone.id);
                            delete(this.gridData.tetris.zones[z]);
                            newZones--;
                            updatedZones[zone.id] = 1;
                            if (newZones == 0) {
                                this.gridTetrisFinishRun(updatedZones);
                            }
                        }).bind(this));
                    }
                }
                if (newZones == 0) {
                    this.gridTetrisFinishRun(updatedZones);
                }
            } else {
                this.setBusy(false);
            }
        }).bind(this));
    }

    gridTetrisFinishRun(updatedZones) {
        this.zoneBulkActionComplete('gridTetrisRun');
        this.jobsRefresh(updatedZones);
        delete(updatedZones['!']);
        var newgeoms = {};
        for (var z in updatedZones) {
            if (this.gridData.tetris.zones[z] && this.gridData.tetris.zones[z].label) {
                if (this.zones[z]) {
                    this.Map.UORemove(this.gridData.tetris.zones[z].label.id);
                    this.gridData.tetris.zones[z].label = this.gridTetrisCreateHandleLabel(z);
                    if (this.zones[z].attributes) {
                        if (!this.zones[z].attributes.tetris) {
                            this.zones[z].attributes.tetris = {};
                        }
                        this.zones[z].attributes.tetris.root = this.gridData.tetris.zones[z].coords;
                        this.zones[z].attributes.tetris.maxLoad = this.gridData.tetris.zones[z].maxLoad;
                    }
                    newgeoms[z] = this.zones[z].geom;
                }
            }
        }
        this.zonesOnChange(newgeoms, this.checkValidity());
        this.gridUpdateZonesVolume().then((() => {
            this.gridTetrisEstimateRoutes(Object.keys(updatedZones));
            this.setBusy(false);
        }).bind(this));
    }

    gridTetrisCreateHandle(zone) {
        if (this.gridData.tetris.zones[zone.id].handle) {
            this.Map.UORemove(this.gridData.tetris.zones[zone.id].handle.id);
        }
        var balloonContent = document.createElement('div');
        balloonContent.className = 'grid-tetris-balloon';
        balloonContent.innerHTML = '<div>Maksymalny wolumen:</div><div class="grid-tetris-balloon-volume-control"></div>';
        let input = new InputNumberStepper({
            target: balloonContent.querySelector('.grid-tetris-balloon-volume-control'),
            props: {
                value: zone.attributes.tetris.maxLoad,
                integerOnly: true,
                steps: [Math.round(this.gridData.tetris.zones[zone.id].maxLoad*0.05), Math.round(this.gridData.tetris.zones[zone.id].maxLoad*0.25)],
                min: 1,
                disabled: zone.attributes.tetris.locked
            }
        });
        input.$on('change', (event) => {
            this.gridData.tetris.zones[zone.id].newMaxLoad = event.detail.value;
        });
        var toggleLock = document.createElement('div');
        toggleLock.appendChild(document.createElement('span'));
        toggleLock.className = 'grid-tetris-balloon-toggle-lock';
        toggleLock.style.cssText = 'text-align: center';
        toggleLock.firstChild.style.cssText = 'cursor: pointer';
        toggleLock.firstChild.addEventListener('click', this.gridTetrisToggleZoneLock.bind(this, zone.id));
        balloonContent.appendChild(toggleLock);
        var routeInfo = document.createElement('div');
        routeInfo.className = 'grid-tetris-balloon-route-info';
        routeInfo.style.cssText = 'display: none; border-top: 1px solid #bbbbbb; margin-top: 5px; padding-top: 3px; font-size: 11px; color: #bbbbbb';
        balloonContent.appendChild(routeInfo);
        var handle = new Targeo.MapObject.Point(
            this.gridData.tetris.zones[zone.id].coords,
            Targeo.Base.createSVGIcon((this.gridData.tetris.zones[zone.id].locked ? ZoneEditor.gridTetrisHandleLocked : ZoneEditor.gridTetrisHandle).replace('{color}', zone.color).replace(/\{fgColor\}/g, this.zoneGetContrastingColor(zone)), 32, 32, 16, 16),
            null,
            {
                balloon: {body: balloonContent, width: 220},
                draggable: true
            }
        );
        handle._balloonContent = balloonContent;
        handle._loadInput = input;
        this.gridData.tetris.zones[zone.id].handleListeners = [
            handle.listen('onMouseOver', (function(handle) { if (!this.zones[zone.id].attributes.tetris.locked) handle.setIcon(Targeo.Base.createSVGIcon(ZoneEditor.gridTetrisHandleMovable.replace('{color}', this.zones[zone.id].color).replace(/\{fgColor\}/g, this.zoneGetContrastingColor(zone)), 32, 32, 16, 16)); }).bind(this, handle)),
            handle.listen('onMouseOut', (function(handle) { if (!this.zones[zone.id].attributes.tetris.locked) handle.setIcon(Targeo.Base.createSVGIcon(ZoneEditor.gridTetrisHandle.replace('{color}', this.zones[zone.id].color).replace(/\{fgColor\}/g, this.zoneGetContrastingColor(zone)), 32, 32, 16, 16)); }).bind(this, handle)),
            handle.listen('onDrag', (function(zoneId, ev) {
                console.log('ZoneEditor, tetris, onDrag', zoneId, this.gridData.tetris.zones[zoneId].label);
                this.Map.UORemove(this.gridData.tetris.zones[zoneId].label.id);
            }).bind(this, zone.id)),
            handle.listen('onDragEnd', (function(zoneId, ev) {
                this.gridData.tetris.zones[zoneId].coords = this.gridData.tetris.zones[zoneId].handle.coords;
                this.gridTetrisRun();
            }).bind(this, zone.id)),
            handle.listen('onBalloonHide', (function(zoneId, ev) {
                console.log('onBalloonHide', this.gridData.tetris.zones[zone.id].newMaxLoad, this.gridData.tetris.zones[zoneId].maxLoad);
                if (this.gridData.tetris.zones[zone.id].newMaxLoad) {
                    if (this.gridData.tetris.zones[zoneId].newMaxLoad != this.gridData.tetris.zones[zoneId].maxLoad) {
                        this.gridData.tetris.zones[zoneId].maxLoad = this.gridData.tetris.zones[zone.id].newMaxLoad;
                        input.$set({steps: [Math.round(this.gridData.tetris.zones[zoneId].maxLoad*0.05), Math.round(this.gridData.tetris.zones[zoneId].maxLoad*0.25)]});
                        this.gridTetrisRun();
                    }
                    delete(this.gridData.tetris.zones[zoneId].newMaxLoad);
                }
            }).bind(this, zone.id)),
        ];
        this.Map.UOAdd(handle);
        return handle;
    }

    gridTetrisCreateHandleLabel(zoneId) {
        var zone = this.zones[zoneId];
        if (zone) {
            if (this.gridData.tetris.zones[zoneId].label) {
                this.Map.UORemove(this.gridData.tetris.zones[zoneId].label.id);
            }
            let fgColor = this.zoneGetContrastingColor(zone);
            var contents =
                ('<div style="text-align: center; color: '+fgColor+'; background-color: '+zone.color+'; border: 1px solid '+fgColor+'; border-radius: 5px; padding: 3px 5px; opacity: 0.8">'
                    + (zone.name ? '<div>'+zone.name+'</div>' : '')
                    + '<div>'
                    + '<img src="'+Targeo.Base.getSVGSrc(ZoneEditor.gridTetrisLoadIcon.replace('{color}', fgColor))+'" style="width: 16px; height: 16px; vertical-align: middle; margin-right: 2px"/>'
                    + '<span style="font-weight: bold">'+(zone.attributes.volume ? (Math.round(zone.attributes.volume.volume*100)/100).toLocaleString() : '0')+'</span>'
                    + '</div>'
                    + (zone.attributes.route && zone.attributes.route.eta && !zone.attributes.route.recalculating ? '<div><img src="'+Targeo.Base.getSVGSrc(ZoneEditor.gridTetrisDurationIcon.replace(/\{color\}/g, fgColor))+'" style="width: 16px; height: 16px; vertical-align: middle; margin-right: 2px"/><span style="font-weight: bold">'+this.formatRouteDuration(zone.attributes.route.eta)+'</span></div>' : '')
                +'</div>');
            var label = new Targeo.MapObject.DOM(
                this.gridData.tetris.zones[zone.id].coords,
                contents,
                null,
                {
                    valign: 'top',
                    offset: {x: 0, y: -18}
                }
            )
            this.Map.UOAdd(label);
            this.gridTetrisSetZoneRouteInfo(zoneId);
            this.gridTetrisSetLockToggle(zoneId);
            return label;
        }
        return null;
    }

    gridTetrisEstimateRoutes(zoneIds) {
        var zones = {};
        for (var i = 0; i < zoneIds.length; i++) {
            if (this.zones[zoneIds[i]]) {
                if (!this.zones[zoneIds[i]].attributes) {
                    this.zones[zoneIds[i]].attributes = {};
                }
                zones[zoneIds[i]] = this.zones[zoneIds[i]].attributes.route ? this.zones[zoneIds[i]].attributes.route.hash : '';
                if (this.zones[zoneIds[i]].attributes.route) {
                    this.zones[zoneIds[i]].attributes.route.recalculating = true;
                }
                if (this.gridData.tetris) {
                    this.gridData.tetris.zones[zoneIds[i]].label = this.gridTetrisCreateHandleLabel(zoneIds[i]);
                }
            }
        }
        if (Object.keys(zones).length > 0) {
            get(api).getData(
                'post',
                '/micro_grid/estimate_zone_routes',
                {
                    ...this.gridGetDefaultAPIParams(),
                    zones: zones,
                    days: this.jobDateRange[1] - this.jobDateRange[0] + 1,
                    volume: this.options.grid.volume
                },
                z.any(),
                z.any()
            ).then(((response) => {
                for (var zoneId in response) {
                    if (response[zoneId].request) {
                        this.zones[zoneId].attributes.route = response[zoneId];
                    } else {
                        if (this.zones[zoneId].attributes.route) {
                            if (response[zoneId].hash) {
                                delete(this.zones[zoneId].attributes.route.recalculating);
                                if (this.zones[zoneId].attributes.route.eta && this.gridData.tetris) {
                                    this.gridData.tetris.zones[zoneId].label = this.gridTetrisCreateHandleLabel(zoneId);
                                    this.Map.UOAdd(this.gridData.tetris.zones[zoneId].label);
                                } else {
                                    this.polygonAddLabel(this.zones[zoneId]._polygon);
                                }
                            } else {
                                delete(this.zones[zoneId].attributes.route);
                                if (this.gridData.tetris) {
                                    this.gridData.tetris.zones[zoneId].label = this.gridTetrisCreateHandleLabel(zoneId);
                                    this.Map.UOAdd(this.gridData.tetris.zones[zoneId].label);
                                } else {
                                    this.polygonAddLabel(this.zones[zoneId]._polygon);
                                }
                            }
                        }
                        delete(zones[zoneId]);
                    }
                }
                if (Object.keys(zones).length > 0) {
                    if (this.routeEstimationTO) {
                        clearTimeout(this.routeEstimationTO);
                    }
                    this.routeEstimationTO = setTimeout(this.gridTetrisGetZoneRoutesEstimation.bind(this), 1000);
                }
            }).bind(this));
        }
    }

    gridTetrisGetZoneRoutesEstimation() {
        var zones = {};
        for (var zoneId in this.zones) {
            if (this.zones[zoneId] && this.zones[zoneId].attributes.route && this.zones[zoneId].attributes.route.request) {
                zones[zoneId] = this.zones[zoneId].attributes.route.request;
            }
        }
        if (Object.keys(zones).length > 0) {
            get(api).getData(
                'post',
                '/micro_grid/get_zone_routes_estimation',
                {
                    ...this.gridGetDefaultAPIParams(),
                    zones: zones,
                    days: this.jobDateRange[1] - this.jobDateRange[0] + 1
                },
                z.any(),
                z.any()
            ).then(((response) => {
                for (var zoneId in response) {
                    if (response[zoneId].hash == this.zones[zoneId].attributes.route.hash) {
                        if (response[zoneId].eta) {
                            this.zones[zoneId].attributes.route = response[zoneId];
                        } else {
                            this.zones[zoneId].attributes.route = null;
                        }
                    } else {
                        this.zones[zoneId].attributes.route = null;
                    }
                    delete(zones[zoneId]);
                    if (this.gridData.tetris) {
                        this.gridData.tetris.zones[zoneId].label = this.gridTetrisCreateHandleLabel(zoneId);
                        this.Map.UOAdd(this.gridData.tetris.zones[zoneId].label);
                    } else {
                        this.polygonAddLabel(this.zones[zoneId]._polygon);
                    }
                }
                if (Object.keys(zones).length > 0) {
                    if (this.routeEstimationTO) {
                        clearTimeout(this.routeEstimationTO);
                    }
                    this.routeEstimationTO = setTimeout(this.gridTetrisGetZoneRoutesEstimation.bind(this), 1000);
                }
            }).bind(this));
        }
    }

    gridTetrisSetZoneRouteInfo(zoneId) {
        var container = this.gridData.tetris.zones[zoneId].handle._balloonContent.querySelector('.grid-tetris-balloon-route-info');
        if (container) {
            var route = this.zones[zoneId].attributes.route;
            if (route && !route.recalculating && route.params) {
                var text = [];
                if (route.params.warehouse) {
                    text.push('Magazyn: '+route.params.warehouse);
                }
                text.push('Czas jazdy: '+route.params.driving_time);
                text.push('Czas serwisowy: '+(route.params.stops+' stopów * '+route.params.delays.stop+' min.') + ' + ' + (route.params.jobs+' zleceń * '+route.params.delays.delivery+' min.'));
                container.innerHTML = text.join('<br/>');
                container.style.display = 'block';
                console.log('ZoneEditor, gridTetrisSetZoneRouteInfo', container.innerHTML);
            } else {
                container.innerHTML = '';
                container.style.display = 'none';
            }
        }
    }

    gridTetrisSetLockToggle(zoneId) {
        var container = this.gridData.tetris.zones[zoneId].handle._balloonContent.querySelector('.grid-tetris-balloon-toggle-lock').firstChild;
        if (container) {
            var locked = this.zones[zoneId].attributes.tetris.locked;
            if (locked) {
                container.innerHTML = '<img src="'+Targeo.Base.getSVGSrc(ZoneEditor.gridTetrisUnlockIcon, 24, 24)+'" style="width: 24px; height: 24px; vertical-align: middle"/> odblokuj';
            } else {
                container.innerHTML = '<img src="'+Targeo.Base.getSVGSrc(ZoneEditor.gridTetrisLockIcon, 24, 24)+'" style="width: 24px; height: 24px; vertical-align: middle"/> zablokuj';
            }
            this.gridData.tetris.zones[zoneId].handle._loadInput.$set({disabled: locked});
        }
    }

    gridTetrisToggleZoneLock(zoneId) {
        this.zones[zoneId].attributes.tetris.locked = !this.zones[zoneId].attributes.tetris.locked;
        this.gridData.tetris.zones[zoneId].locked = this.zones[zoneId].attributes.tetris.locked;
        this.gridData.tetris.zones[zoneId].handle.setIcon(Targeo.Base.createSVGIcon((this.zones[zoneId].attributes.tetris.locked ? ZoneEditor.gridTetrisHandleLocked : ZoneEditor.gridTetrisHandleMovable).replace('{color}', this.zones[zoneId].color).replace(/\{fgColor\}/g, this.zoneGetContrastingColor(this.zones[zoneId])), 32, 32, 16, 16));
        this.gridData.tetris.zones[zoneId].handle.setDraggable(!this.zones[zoneId].attributes.tetris.locked);
        this.gridTetrisSetLockToggle(zoneId);
    }

    gridLegend() {
        if (this.editMode == 'grid') {
            if (!this.gridLegendElement) {
                this.gridLegendElement = document.createElement('div');
                this.gridLegendElement.className = 'targeo-polygoneditor-legend';
            }
            var legendHTML = [];
            if (this.Map.getZoom() > 23) {
                legendHTML.push('<div>'+this.options.translateFunc('editor_grid_legend_zoom_in_to_see_cells')+'</div>');
            }
            if (this.gridData.tetris) {
                legendHTML.push('<div>'+this.options.translateFunc('editor_grid_legend_tetris_click_to_add_zone')+'</div>');
                legendHTML.push('<div>'+this.options.translateFunc('editor_grid_legend_tetris_drag_to_modify_zone')+'</div>');
            } else {
                legendHTML.push('<div>'+this.options.translateFunc('editor_grid_legend_click_to_reassign')+'</div>');
                legendHTML.push('<div>'+this.options.translateFunc('editor_grid_legend_ctrl_click_to_add_cell_to_selection')+'</div>');
                legendHTML.push('<div>'+this.options.translateFunc('editor_grid_legend_ctrl_alt_click_to_add_zone_to_selection')+'</div>');
                legendHTML.push('<div>'+this.options.translateFunc('editor_grid_legend_shift_click_to_start_drawing_selection')+'</div>');
                legendHTML.push('<div>'+this.options.translateFunc('editor_grid_legend_right_click_to_show_options')+'</div>');
            }
            this.gridLegendElement.innerHTML = legendHTML.join('');
            if (!this.gridLegendControl) {
                var legendControlElement = document.createElement('div');
                legendControlElement.className = 'targeo-control targeo-polygoneditor-legend-control';
                var legendControlSwitch = document.createElement('div');
                legendControlSwitch.className = 'targeo-polygoneditor-legend-switch';
                legendControlSwitch.innerHTML = '?';
                legendControlElement.append(this.gridLegendElement, legendControlSwitch);
                this.gridLegendControl = this.Map.modules.Controls.addControl('zone-editor-grid-legend', legendControlElement, {align: 'right-bottom'});
            }
        } else if (this.gridLegendControl) {
            this.Map.modules.Controls.removeControl('zone-editor-grid-legend');
            this.gridLegendControl = null;
        }
    }

    setBusy(busy) {
        var wasBusy = this.isBusy > 0;
        if (busy) {
            this.isBusy++;
        } else {
            this.isBusy--;
        }
        this.isBusy = Math.max(0, this.isBusy);
        if ((this.isBusy > 0) !== wasBusy) {
            this.dispatchEvent(new CustomEvent('onBusy', {detail: {busy: this.isBusy > 0}}));
        }
    }

    formatRouteDuration(eta) {
        return (eta >= 60 ? (Math.floor(eta/60) + '<span style="font-weight: normal">h</span> ') : '')+((Math.round(eta) % 60));
    }

}

ZoneEditor.activeEditor = null;

ZoneEditor.iconJob = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="{color}"><path d="M 240 -600 h 480 v -80 H 240 v 80 Z M 120 -80 v -680 q 0 -33 23.5 -56.5 T 200 -840 h 560 q 33 0 56.5 23.5 T 840 -760 v 562 h -80 v -562 H 200 v 562 h 640 v 105 l -60 -60 l -60 60 l -60 -60 l -60 60 l -60 -60 l -60 60 l -60 -60 l -60 60 l -60 -60 l -60 60 l -60 -60 l -60 60 Z m 120 -200 h 480 v -80 H 240 v 80 Z m 0 -160 h 480 t 0 -80 H 240 v 80 Z m -40 242 v -562 v 562 Z"/></svg>';

ZoneEditor.iconParcel = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="{color}"><path d="M440-183v-274L200-596v274l240 139Zm80 0 240-139v-274L520-457v274Zm-80 92L160-252q-19-11-29.5-29T120-321v-318q0-22 10.5-40t29.5-29l280-161q19-11 40-11t40 11l280 161q19 11 29.5 29t10.5 40v318q0 22-10.5 40T800-252L520-91q-19 11-40 11t-40-11Zm200-528 77-44-237-137-78 45 238 136Zm-160 93 78-45-237-137-78 45 237 137Z"/></svg>';

ZoneEditor.iconStop = '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="{color}"><path d="M536.5-503.5Q560-527 560-560t-23.5-56.5Q513-640 480-640t-56.5 23.5Q400-593 400-560t23.5 56.5Q447-480 480-480t56.5-23.5ZM480-186q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z"/></svg>';

ZoneEditor.iconNoVehicle = `
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="-200 -1210 1360 1360" fill="#ffffff">
        <circle cx="480" cy="-500" r="580" fill="#ff0000" stroke="#ffffff" stroke-width="100"/>
        <path d="M155-195q-35-35-35-85H40v-440q0-33 23.5-56.5T120-800h560v160h120l120 160v200h-80q0 50-35 85t-85 35q-50 0-85-35t-35-85H360q0 50-35 85t-85 35q-50 0-85-35Zm113.5-56.5Q280-263 280-280t-11.5-28.5Q257-320 240-320t-28.5 11.5Q200-297 200-280t11.5 28.5Q223-240 240-240t28.5-11.5ZM120-360h32q17-18 39-29t49-11q27 0 49 11t39 29h272v-360H120v360Zm628.5 108.5Q760-263 760-280t-11.5-28.5Q737-320 720-320t-28.5 11.5Q680-297 680-280t11.5 28.5Q703-240 720-240t28.5-11.5ZM680-440h170l-90-120h-80v120ZM360-540Z"/>
        <line x1="100" y1="-860" x2="900" y2="-200" stroke-width="200" stroke="#ff0000"/>
        <line x1="40" y1="-890" x2="940" y2="-170" stroke-width="100" stroke="#ffffff"/>
    </svg>
`;

ZoneEditor.gridMoveArrow = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 124 124" fill="none">
        <filter id="neon">
            <feFlood flood-color="rgb(255,255,255)" flood-opacity="0.5" in="SourceGraphic" />
            <feComposite operator="in" in2="SourceGraphic" />
            <feGaussianBlur stdDeviation="10" />
            <feComponentTransfer result="glow1">
                <feFuncA type="linear" slope="4" intercept="0" />
            </feComponentTransfer>
            <feMerge>
                <feMergeNode in="glow1" />
                <feMergeNode in="SourceGraphic" />
            </feMerge>
        </filter>
        <g filter="url(#neon)">
            <line x1="62" y1="100" x2="62" y2="20" stroke="{color}" stroke-width="10" stroke-linecap="round"/>
            <line x1="42" y1="60" x2="62" y2="20" stroke="{color}" stroke-width="10" stroke-linecap="round"/>
            <line x1="82" y1="60" x2="62" y2="20" stroke="{color}" stroke-width="10" stroke-linecap="round"/>
        </g>
    </svg>
`;

ZoneEditor.gridRemoveIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 100 100" fill="none">
        <filter id="neon">
            <feFlood flood-color="rgb(255,255,255)" flood-opacity="0.5" in="SourceGraphic" />
            <feComposite operator="in" in2="SourceGraphic" />
            <feGaussianBlur stdDeviation="10" />
            <feComponentTransfer result="glow1">
                <feFuncA type="linear" slope="4" intercept="0" />
            </feComponentTransfer>
            <feMerge>
                <feMergeNode in="glow1" />
                <feMergeNode in="SourceGraphic" />
            </feMerge>
        </filter>
        <g filter="url(#neon)">
            <line x1="25" y1="25" x2="75" y2="75" stroke="{color}" stroke-width="10" stroke-linecap="round"/>
            <line x1="25" y1="75" x2="75" y2="25" stroke="{color}" stroke-width="10" stroke-linecap="round"/>
        </g>
    </svg>
`;

ZoneEditor.gridZoneBalanceMarker = `
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
        <circle cx="20" cy="20" r="18" fill="{color}" stroke="#ffffff" stroke-width="3"/>
        <line x1="12" y1="20" x2="28" y2="20" stroke="#ffffff" stroke-width="5" stroke-linecap="round"/>
        <line x1="21" y1="13" x2="28" y2="20" stroke="#ffffff" stroke-width="5" stroke-linecap="round"/>
        <line x1="21" y1="27" x2="28" y2="20" stroke="#ffffff" stroke-width="5" stroke-linecap="round"/>
    </svg>
`;

ZoneEditor.gridTetrisHandle = `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 -1060 1060 1060" fill="none">
        <circle cx="530" cy="-530" r="480" fill="{color}" stroke="{fgColor}" stroke-width="50"/>
    </svg>
`;

ZoneEditor.gridTetrisHandleMovable = `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 -1060 1060 1060" fill="none">
        <circle cx="530" cy="-530" r="480" fill="{color}" stroke="{fgColor}" stroke-width="50"/>
        <g transform="translate(50,-50)">
            <path d="M480-80 310-250l57-57 73 73v-206H235l73 72-58 58L80-480l169-169 57 57-72 72h206v-206l-73 73-57-57 170-170 170 170-57 57-73-73v206h205l-73-72 58-58 170 170-170 170-57-57 73-73H520v205l72-73 58 58L480-80Z" fill="{fgColor}"/>
        </g>
    </svg>
`;

ZoneEditor.gridTetrisHandleLocked = `
    <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -1060 1060 1060" width="32px" fill="none">
        <circle cx="530" cy="-530" r="480" fill="{color}" stroke="{fgColor}" stroke-width="50"/>
        <g transform="translate(145,-140) scale(0.8)">
            <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm296.5-143.5Q560-327 560-360t-23.5-56.5Q513-440 480-440t-56.5 23.5Q400-393 400-360t23.5 56.5Q447-280 480-280t56.5-23.5ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z" fill="{fgColor}"/>
        </g>
    </svg>
`;

ZoneEditor.gridTetrisLoadIcon = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="{color}"><path d="M80-80v-160h800v160H760v-80H540v80H420v-80H200v80H80Zm160-240q-17 0-28.5-11.5T200-360v-480q0-17 11.5-28.5T240-880h480q17 0 28.5 11.5T760-840v480q0 17-11.5 28.5T720-320H240Zm40-80h400v-400H280v400Zm80-240h240v-80H360v80Zm-80 240v-400 400Z"/></svg>`;

ZoneEditor.gridTetrisDurationIcon = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="{color}"><path d="m612-292 56-56-148-148v-184h-80v216l172 172ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-400Zm0 320q133 0 226.5-93.5T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160Z"/></svg>`;

ZoneEditor.gridTetrisLockIcon = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm296.5-143.5Q560-327 560-360t-23.5-56.5Q513-440 480-440t-56.5 23.5Q400-393 400-360t23.5 56.5Q447-280 480-280t56.5-23.5ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z"/></svg>`;

ZoneEditor.gridTetrisUnlockIcon = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M240-640h360v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85h-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640Zm0 480h480v-400H240v400Zm296.5-143.5Q560-327 560-360t-23.5-56.5Q513-440 480-440t-56.5 23.5Q400-393 400-360t23.5 56.5Q447-280 480-280t56.5-23.5ZM240-160v-400 400Z"/></svg>`;